import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID3gxj6tk5isa35 as VOID,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  toString1pkumu07cwy4m as toString,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  IllegalArgumentException_init_$Init$1blytbdgl1fky as IllegalArgumentException_init_$Init$,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException_init_$Init$1ke5df1bctk2y as IllegalArgumentException_init_$Init$_0,
  IllegalArgumentException_init_$Init$jyc1udwa6hs3 as IllegalArgumentException_init_$Init$_1,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  Triple1vhi3d0dgpnjb as Triple,
  getKClass3t8tygqu4lcxf as getKClass,
  Paire9pteg33gng7 as Pair,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  HashMap1a0ld5kgwhmhv as HashMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashSet2dzve9y63nf0v as HashSet,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
  ArrayList3it5z8td81qkl as ArrayList,
  copyToArray2j022khrow2yi as copyToArray,
  _Result___get_value__impl__bjfvqg2ei4op8d4d2m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivrr0d11rbi6gb as _Result___get_isFailure__impl__jpiriv,
  Result3t1vadv16kmzk as Result,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  isBlank1dvkhjjvox3p0 as isBlank,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  toList383f556t1dixk as toList,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$_0,
  HashSet_init_$Create$3vvk876hypkbb as HashSet_init_$Create$,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  until1jbpn0z3f8lbg as until,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  Char19o2r8palgjof as Char,
  Duration__toIsoString_impl_9h6wsm3b9pty5ms72ij as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance1cdckxf15vkye as Companion_getInstance_0,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  hashCodeq5arwsb9dgti as hashCode,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  ArrayList_init_$Create$1k9mng94yui0r as ArrayList_init_$Create$_1,
  HashSet_init_$Create$2moxdurliew19 as HashSet_init_$Create$_0,
  LinkedHashSet_init_$Create$3o6z3oewjhki9 as LinkedHashSet_init_$Create$,
  LinkedHashSet_init_$Create$35d0fbehwrao9 as LinkedHashSet_init_$Create$_0,
  HashMap_init_$Create$2pprpqyxxsq9t as HashMap_init_$Create$,
  HashMap_init_$Create$b8oqvbb9c2yv as HashMap_init_$Create$_0,
  LinkedHashMap_init_$Create$1f9mb1z5f3dxn as LinkedHashMap_init_$Create$,
  LinkedHashMap_init_$Create$jfk1f3iu2ll6 as LinkedHashMap_init_$Create$_0,
  isArray1hxjqtqy632bc as isArray,
  arrayIterator3lgwvgteckzhv as arrayIterator,
  asList2ho2pewtsfvv as asList,
  step18s9qzr5xwxat as step,
  getValue48kllevslyh6 as getValue,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  shiftLeft1ck77p6vapyra as shiftLeft,
  bitwiseOr1ita6dahwp8zb as bitwiseOr,
  equalsLong28bsrfhwvd686 as equalsLong,
  invert3i8k5n0dd6oib as invert,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  HashSet_init_$Create$1almu45bw06ne as HashSet_init_$Create$_1,
  toString30pk9tzaqopn as toString_0,
  KTypeParameter1s8efufd4mbj5 as KTypeParameter,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  Companion_getInstance2e3h8n26rh23 as Companion_getInstance_1,
  isCharArray21auq5hbrg68m as isCharArray,
  charArray2ujmm1qusno00 as charArray,
  DoubleCompanionObject_instance3q51gr7gsd0au as DoubleCompanionObject_instance,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  FloatCompanionObject_instance367t6x2s4xzmv as FloatCompanionObject_instance,
  isFloatArrayjjscnqphw92j as isFloatArray,
  Companion_getInstance3gn12jgnf4xoo as Companion_getInstance_2,
  isLongArray2fdt3z7yu3ef as isLongArray,
  Companion_getInstance1puqqwzccfvrg as Companion_getInstance_3,
  _ULongArray___get_size__impl__ju6dtr2cm0h8pvj33oc as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l318nadwrsl904i as _ULongArray___init__impl__twm1l3,
  _ULong___init__impl__c78o9k1p6qzv0dh0bvg as _ULong___init__impl__c78o9k,
  ULongArray__get_impl_pr71q9ba20e4znze0l as ULongArray__get_impl_pr71q9,
  _ULong___get_data__impl__fggpzb2qlkrfp9zs48z as _ULong___get_data__impl__fggpzb,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  isIntArrayeijsubfngq38 as isIntArray,
  Companion_getInstanceuedpedmz4g65 as Companion_getInstance_4,
  _UIntArray___get_size__impl__r6l8ci2fqw6ae893py3 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc618b75h631neq9 as _UIntArray___init__impl__ghjpc6,
  _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl,
  UIntArray__get_impl_gp5kza2hxcr782v503s as UIntArray__get_impl_gp5kza,
  _UInt___get_data__impl__f0vqqw13y1a2xkii3dn as _UInt___get_data__impl__f0vqqw,
  ShortCompanionObject_instance3vq120mx8545m as ShortCompanionObject_instance,
  isShortArraywz30zxwtqi8h as isShortArray,
  Companion_getInstance2du03jiluw9jj as Companion_getInstance_5,
  _UShortArray___get_size__impl__jqto1b1rcopfj002me5 as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef2aumgbpdmuy5g as _UShortArray___init__impl__9b26ef,
  _UShort___init__impl__jigrne2jag2u7194ozm as _UShort___init__impl__jigrne,
  UShortArray__get_impl_fnbhmx31xgjirit34wn as UShortArray__get_impl_fnbhmx,
  _UShort___get_data__impl__g0245hlms5v6vgvnl as _UShort___get_data__impl__g0245,
  ByteCompanionObject_instance9rvhjp0l184i as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Companion_getInstance1trnkq9cty7vr as Companion_getInstance_6,
  _UByteArray___get_size__impl__h6pkdv1cve284ztupz4 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n23n7lz0x7gq72 as _UByteArray___init__impl__ip4y9n,
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  UByteArray__get_impl_t5f3hvz1l7xhrol2kb as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr,
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  _ULongArray___get_storage__impl__28e64jd93r4nwx0bzi as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l310ecgw67nsok9 as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh2wf37xvulocfs as ULongArray__set_impl_z19mvh,
  copyOf3rutauicler23 as copyOf_3,
  _UIntArray___get_storage__impl__92a0v02db5qclx33scp as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc617c61a9kgqgj3 as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu21rg83h8k5rr6q as UIntArray__set_impl_7f2zu2,
  copyOf39s58md6y6rn6 as copyOf_4,
  _UShortArray___get_storage__impl__t2jpv516i6vr5ztry4u as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef3ghkk09gj85t3 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp1o84pp60fh8tm as UShortArray__set_impl_6d8whp,
  copyOfwy6h3t5vzqpl as copyOf_5,
  _UByteArray___get_storage__impl__d4kctt25iva2n6yox0m as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9ndqanl1uze050 as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicnym486up0f2lk as UByteArray__set_impl_jvcicn,
  copyOf37mht4mx7mjgh as copyOf_6,
  Unitkvevlwgzwiuc as Unit,
  trimIndent1qytc1wvt8suh as trimIndent,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  UInt1hthisrv6cndi as UInt,
  ULong3f9k7s38t3rfp as ULong,
  UBytep4j7r1t64gz1 as UByte,
  UShort26xnqty60t7le as UShort,
  get_indicesc04v40g017hw as get_indices,
  IndexOutOfBoundsException_init_$Create$2w5dv25cjssuw as IndexOutOfBoundsException_init_$Create$,
  get_indices377latqcai313 as get_indices_0,
  PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance,
  mapOf1xd03cq9cnmy8 as mapOf,
  get_js1ale1wr4fbvs0 as get_js,
  findAssociatedObject1kb88g16k1goa as findAssociatedObject,
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
function get_isNullable() {
  return false;
}
function get_isInline() {
  return false;
}
function get_annotations() {
  return emptyList();
}
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(elementDescriptors$$inlined$Iterable$1);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
initMetadataForInterface(CachedNames, 'CachedNames');
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
function decodeSerializableValue(deserializer) {
  return deserializer.lf(this);
}
initMetadataForInterface(Decoder, 'Decoder');
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.si(descriptor, index, deserializer, previousValue) : $super.si.call(this, descriptor, index, deserializer, previousValue);
}
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
function encodeNotNullMark() {
}
function beginCollection(descriptor, collectionSize) {
  return this.gi(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.kf(this, value);
}
initMetadataForInterface(Encoder, 'Encoder');
initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder]);
initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(SerializerFactory, 'SerializerFactory');
initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
initMetadataForClass(createCache$1);
initMetadataForClass(createParametrizedCache$1);
//endregion
function KSerializer() {
}
function SerializationStrategy() {
}
function DeserializationStrategy() {
}
function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.uf('type', serializer_0(StringCompanionObject_instance).jf());
    $this$buildSerialDescriptor.uf('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.vf_1.v7() + '>', CONTEXTUAL_getInstance(), []));
    $this$buildSerialDescriptor.of_1 = this$0.wf_1;
    return Unit_instance;
  };
}
function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
  return function () {
    var tmp = OPEN_getInstance();
    return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.vf_1);
  };
}
function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
  return function (p0) {
    return p0.jf();
  };
}
function PolymorphicSerializer(baseClass) {
  AbstractPolymorphicSerializer.call(this);
  this.vf_1 = baseClass;
  this.wf_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.xf_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
}
protoOf(PolymorphicSerializer).yf = function () {
  return this.vf_1;
};
protoOf(PolymorphicSerializer).jf = function () {
  var tmp0 = this.xf_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
  return tmp0.n1();
};
protoOf(PolymorphicSerializer).toString = function () {
  return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.vf_1) + ')';
};
function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.bg(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.yf());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.ag(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.yf());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
  return function (p0) {
    return p0.jf();
  };
}
function SealedClassSerializer() {
}
protoOf(SealedClassSerializer).jf = function () {
  var tmp0 = this.cg_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
  return tmp0.n1();
};
function SerializationException_init_$Init$($this) {
  IllegalArgumentException_init_$Init$($this);
  SerializationException.call($this);
  return $this;
}
function SerializationException_init_$Create$() {
  var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
  captureStack(tmp, SerializationException_init_$Create$);
  return tmp;
}
function SerializationException_init_$Init$_0(message, $this) {
  IllegalArgumentException_init_$Init$_0(message, $this);
  SerializationException.call($this);
  return $this;
}
function SerializationException_init_$Create$_0(message) {
  var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
  captureStack(tmp, SerializationException_init_$Create$_0);
  return tmp;
}
function SerializationException_init_$Init$_1(message, cause, $this) {
  IllegalArgumentException_init_$Init$_1(message, cause, $this);
  SerializationException.call($this);
  return $this;
}
function SerializationException() {
  captureStack(this, SerializationException);
}
function UnknownFieldException_init_$Init$(index, $this) {
  UnknownFieldException.call($this, 'An unknown field for index ' + index);
  return $this;
}
function UnknownFieldException_init_$Create$(index) {
  var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
  captureStack(tmp, UnknownFieldException_init_$Create$);
  return tmp;
}
function UnknownFieldException(message) {
  SerializationException_init_$Init$_0(message, this);
  captureStack(this, UnknownFieldException);
}
function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
  MissingFieldException.call($this, missingFields, missingFields.k() === 1 ? "Field '" + missingFields.m(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  return $this;
}
function MissingFieldException_init_$Create$(missingFields, serialName) {
  var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
  captureStack(tmp, MissingFieldException_init_$Create$);
  return tmp;
}
function MissingFieldException(missingFields, message, cause) {
  SerializationException_init_$Init$_1(message, cause, this);
  captureStack(this, MissingFieldException);
  this.dg_1 = missingFields;
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s = typeArguments.h();
    while (_iterator__ex2g4s.i()) {
      var item = _iterator__ex2g4s.j();
      var tmp$ret$0 = serializer(_this__u8e3s4, item);
      destination.f(tmp$ret$0);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s_0 = typeArguments.h();
    while (_iterator__ex2g4s_0.i()) {
      var item_0 = _iterator__ex2g4s_0.j();
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$3 = tmp_0;
      destination_0.f(tmp$ret$3);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function serializer(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
    tmp = new ArrayListSerializer(serializers.m(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
    tmp = new HashSetSerializer(serializers.m(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
    tmp = new LinkedHashSetSerializer(serializers.m(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
    tmp = new HashMapSerializer(serializers.m(0), serializers.m(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
    tmp = new LinkedHashMapSerializer(serializers.m(0), serializers.m(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry))) {
    tmp = MapEntrySerializer(serializers.m(0), serializers.m(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair))) {
    tmp = PairSerializer(serializers.m(0), serializers.m(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple))) {
    tmp = TripleSerializer(serializers.m(0), serializers.m(1), serializers.m(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.m(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.k8();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.j8();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.h();
  while (_iterator__ex2g4s.i()) {
    var item = _iterator__ex2g4s.j();
    var tmp$ret$0 = typeOrThrow(item);
    destination.f(tmp$ret$0);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.l()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.fg(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.eg()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_2;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_2 = null;
      } else {
        var tmp_3 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
      }
      tmp_1 = tmp_2;
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_4;
  if (typeArguments.l()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.fg(rootClass) : tmp0_elvis_lhs;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    tmp_4 = tmp_5;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_6;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var serializers = tmp_6;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.gg(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_7 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp_4 = tmp_7;
  }
  var contextualSerializer = tmp_4;
  var tmp_8;
  if (contextualSerializer == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_8 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
  }
  var tmp6_safe_receiver = tmp_8;
  return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
}
function serializerByKTypeImpl$lambda($typeArguments) {
  return function () {
    return $typeArguments.m(0).i8();
  };
}
function get_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE;
}
var SERIALIZERS_CACHE;
function get_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE_NULLABLE;
}
var SERIALIZERS_CACHE_NULLABLE;
function get_PARAMETRIZED_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE;
}
var PARAMETRIZED_SERIALIZERS_CACHE;
function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
}
var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
function findCachedSerializer(clazz, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp0_safe_receiver = get_SERIALIZERS_CACHE().hg(clazz);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
    }
    tmp = tmp_0;
  } else {
    tmp = get_SERIALIZERS_CACHE_NULLABLE().hg(clazz);
  }
  return tmp;
}
function findParametrizedCachedSerializer(clazz, types, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().ig(clazz, types);
    tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
  } else {
    tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().ig(clazz, types);
  }
  return tmp;
}
function SERIALIZERS_CACHE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
  }
  return tmp_0;
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
  return function () {
    return $types.m(0).i8();
  };
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
  }
  return tmp;
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
  return function () {
    return $types.m(0).i8();
  };
}
var properties_initialized_SerializersCache_kt_q8kf25;
function _init_properties_SerializersCache_kt__hgwi2p() {
  if (!properties_initialized_SerializersCache_kt_q8kf25) {
    properties_initialized_SerializersCache_kt_q8kf25 = true;
    SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
    SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
  }
}
function serializer_0(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_1(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function serializer_2(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function serializer_3(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function serializer_4(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.jf().jg()) {
    tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new NullableSerializer(_this__u8e3s4);
  }
  return tmp;
}
function serializer_5(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function serializer_7(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function serializer_8(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function CharArraySerializer() {
  return CharArraySerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function DoubleArraySerializer() {
  return DoubleArraySerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function FloatArraySerializer() {
  return FloatArraySerializer_getInstance();
}
function LongArraySerializer() {
  return LongArraySerializer_getInstance();
}
function ULongArraySerializer() {
  return ULongArraySerializer_getInstance();
}
function IntArraySerializer() {
  return IntArraySerializer_getInstance();
}
function UIntArraySerializer() {
  return UIntArraySerializer_getInstance();
}
function ShortArraySerializer() {
  return ShortArraySerializer_getInstance();
}
function UShortArraySerializer() {
  return UShortArraySerializer_getInstance();
}
function ByteArraySerializer() {
  return ByteArraySerializer_getInstance();
}
function UByteArraySerializer() {
  return UByteArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function BooleanArraySerializer() {
  return BooleanArraySerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer() {
  return NothingSerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function serializer_15(_this__u8e3s4) {
  return UuidSerializer_getInstance();
}
function MapEntrySerializer(keySerializer, valueSerializer) {
  return new MapEntrySerializer_0(keySerializer, valueSerializer);
}
function PairSerializer(keySerializer, valueSerializer) {
  return new PairSerializer_0(keySerializer, valueSerializer);
}
function TripleSerializer(aSerializer, bSerializer, cSerializer) {
  return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new ReferenceArraySerializer(kClass, elementSerializer);
}
function MapSerializer(keySerializer, valueSerializer) {
  return new LinkedHashMapSerializer(keySerializer, valueSerializer);
}
function ListSerializer(elementSerializer) {
  return new ArrayListSerializer(elementSerializer);
}
function withContext(_this__u8e3s4, context) {
  return new ContextDescriptor(_this__u8e3s4, context);
}
function ContextDescriptor(original, kClass) {
  this.kg_1 = original;
  this.lg_1 = kClass;
  this.mg_1 = this.kg_1.ng() + '<' + this.lg_1.v7() + '>';
}
protoOf(ContextDescriptor).ng = function () {
  return this.mg_1;
};
protoOf(ContextDescriptor).equals = function (other) {
  var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var another = tmp;
  return equals(this.kg_1, another.kg_1) && another.lg_1.equals(this.lg_1);
};
protoOf(ContextDescriptor).hashCode = function () {
  var result = this.lg_1.hashCode();
  result = imul(31, result) + getStringHashCode(this.mg_1) | 0;
  return result;
};
protoOf(ContextDescriptor).toString = function () {
  return 'ContextDescriptor(kClass: ' + toString(this.lg_1) + ', original: ' + toString(this.kg_1) + ')';
};
protoOf(ContextDescriptor).og = function () {
  return this.kg_1.og();
};
protoOf(ContextDescriptor).jg = function () {
  return this.kg_1.jg();
};
protoOf(ContextDescriptor).pg = function () {
  return this.kg_1.pg();
};
protoOf(ContextDescriptor).qg = function () {
  return this.kg_1.qg();
};
protoOf(ContextDescriptor).rg = function () {
  return this.kg_1.rg();
};
protoOf(ContextDescriptor).sg = function (index) {
  return this.kg_1.sg(index);
};
protoOf(ContextDescriptor).tg = function (name) {
  return this.kg_1.tg(name);
};
protoOf(ContextDescriptor).ug = function (index) {
  return this.kg_1.ug(index);
};
protoOf(ContextDescriptor).vg = function (index) {
  return this.kg_1.vg(index);
};
protoOf(ContextDescriptor).wg = function (index) {
  return this.kg_1.wg(index);
};
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.fg(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.jf();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor) {
    tmp = _this__u8e3s4.lg_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
      tmp = get_capturedKClass(_this__u8e3s4.xg_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function SerialDescriptor() {
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
}
function elementDescriptors$1($this_elementDescriptors) {
  this.bh_1 = $this_elementDescriptors;
  this.ah_1 = $this_elementDescriptors.qg();
}
protoOf(elementDescriptors$1).i = function () {
  return this.ah_1 > 0;
};
protoOf(elementDescriptors$1).j = function () {
  var tmp = this.bh_1.qg();
  var _unary__edvuaz = this.ah_1;
  this.ah_1 = _unary__edvuaz - 1 | 0;
  return this.bh_1.vg(tmp - _unary__edvuaz | 0);
};
function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
  this.ch_1 = $this_elementDescriptors;
}
protoOf(elementDescriptors$$inlined$Iterable$1).h = function () {
  return new elementDescriptors$1(this.ch_1);
};
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.pf_1.k(), toList(typeParameters), sdBuilder);
}
function ClassSerialDescriptorBuilder(serialName) {
  this.mf_1 = serialName;
  this.nf_1 = false;
  this.of_1 = emptyList();
  this.pf_1 = ArrayList_init_$Create$_0();
  this.qf_1 = HashSet_init_$Create$();
  this.rf_1 = ArrayList_init_$Create$_0();
  this.sf_1 = ArrayList_init_$Create$_0();
  this.tf_1 = ArrayList_init_$Create$_0();
}
protoOf(ClassSerialDescriptorBuilder).dh = function (elementName, descriptor, annotations, isOptional) {
  // Inline function 'kotlin.require' call
  if (!this.qf_1.f(elementName)) {
    var message = "Element with name '" + elementName + "' is already registered in " + this.mf_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.plusAssign' call
  this.pf_1.f(elementName);
  // Inline function 'kotlin.collections.plusAssign' call
  this.rf_1.f(descriptor);
  // Inline function 'kotlin.collections.plusAssign' call
  this.sf_1.f(annotations);
  // Inline function 'kotlin.collections.plusAssign' call
  this.tf_1.f(isOptional);
};
protoOf(ClassSerialDescriptorBuilder).uf = function (elementName, descriptor, annotations, isOptional, $super) {
  annotations = annotations === VOID ? emptyList() : annotations;
  isOptional = isOptional === VOID ? false : isOptional;
  var tmp;
  if ($super === VOID) {
    this.dh(elementName, descriptor, annotations, isOptional);
    tmp = Unit_instance;
  } else {
    tmp = $super.dh.call(this, elementName, descriptor, annotations, isOptional);
  }
  return tmp;
};
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.ph_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.n1();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.oh_1);
  };
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return function (p0) {
    return _get__hashCode__tgwhef(p0);
  };
}
function SerialDescriptorImpl$toString$lambda(this$0) {
  return function (it) {
    return this$0.sg(it) + ': ' + this$0.vg(it).ng();
  };
}
function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
  this.eh_1 = serialName;
  this.fh_1 = kind;
  this.gh_1 = elementsCount;
  this.hh_1 = builder.of_1;
  this.ih_1 = toHashSet(builder.pf_1);
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = builder.pf_1;
  tmp.jh_1 = copyToArray(this_0);
  this.kh_1 = compactArray(builder.rf_1);
  var tmp_0 = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = builder.sf_1;
  tmp_0.lh_1 = copyToArray(this_1);
  this.mh_1 = toBooleanArray(builder.tf_1);
  var tmp_1 = this;
  // Inline function 'kotlin.collections.map' call
  var this_2 = withIndex(this.jh_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.h();
  while (_iterator__ex2g4s.i()) {
    var item = _iterator__ex2g4s.j();
    var tmp$ret$2 = to(item.ia_1, item.ha_1);
    destination.f(tmp$ret$2);
  }
  tmp_1.nh_1 = toMap(destination);
  this.oh_1 = compactArray(typeParameters);
  var tmp_2 = this;
  tmp_2.ph_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
}
protoOf(SerialDescriptorImpl).ng = function () {
  return this.eh_1;
};
protoOf(SerialDescriptorImpl).og = function () {
  return this.fh_1;
};
protoOf(SerialDescriptorImpl).qg = function () {
  return this.gh_1;
};
protoOf(SerialDescriptorImpl).rg = function () {
  return this.hh_1;
};
protoOf(SerialDescriptorImpl).qh = function () {
  return this.ih_1;
};
protoOf(SerialDescriptorImpl).sg = function (index) {
  return getChecked(this.jh_1, index);
};
protoOf(SerialDescriptorImpl).tg = function (name) {
  var tmp0_elvis_lhs = this.nh_1.q1(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
};
protoOf(SerialDescriptorImpl).ug = function (index) {
  return getChecked(this.lh_1, index);
};
protoOf(SerialDescriptorImpl).vg = function (index) {
  return getChecked(this.kh_1, index);
};
protoOf(SerialDescriptorImpl).wg = function (index) {
  return getChecked_0(this.mh_1, index);
};
protoOf(SerialDescriptorImpl).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof SerialDescriptorImpl)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.ng() === other.ng())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!contentEquals(this.oh_1, other.oh_1)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.qg() === other.qg())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.qg();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.vg(index).ng() === other.vg(index).ng())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.vg(index).og(), other.vg(index).og())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(SerialDescriptorImpl).hashCode = function () {
  return _get__hashCode__tgwhef(this);
};
protoOf(SerialDescriptorImpl).toString = function () {
  var tmp = until(0, this.gh_1);
  var tmp_0 = this.eh_1 + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
};
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builderAction(sdBuilder);
  return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.pf_1.k(), toList(typeParameters), sdBuilder);
}
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function ENUM() {
  ENUM_instance = this;
  SerialKind.call(this);
}
var ENUM_instance;
function ENUM_getInstance() {
  if (ENUM_instance == null)
    new ENUM();
  return ENUM_instance;
}
function CONTEXTUAL() {
  CONTEXTUAL_instance = this;
  SerialKind.call(this);
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance == null)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
function SerialKind() {
}
protoOf(SerialKind).toString = function () {
  return ensureNotNull(getKClassFromExpression(this).v7());
};
protoOf(SerialKind).hashCode = function () {
  return getStringHashCode(this.toString());
};
function CLASS() {
  CLASS_instance = this;
  StructureKind.call(this);
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance == null)
    new CLASS();
  return CLASS_instance;
}
function LIST() {
  LIST_instance = this;
  StructureKind.call(this);
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance == null)
    new LIST();
  return LIST_instance;
}
function MAP() {
  MAP_instance = this;
  StructureKind.call(this);
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance == null)
    new MAP();
  return MAP_instance;
}
function OBJECT() {
  OBJECT_instance = this;
  StructureKind.call(this);
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance == null)
    new OBJECT();
  return OBJECT_instance;
}
function StructureKind() {
  SerialKind.call(this);
}
function BOOLEAN() {
  BOOLEAN_instance = this;
  PrimitiveKind.call(this);
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance == null)
    new BOOLEAN();
  return BOOLEAN_instance;
}
function BYTE() {
  BYTE_instance = this;
  PrimitiveKind.call(this);
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance == null)
    new BYTE();
  return BYTE_instance;
}
function CHAR() {
  CHAR_instance = this;
  PrimitiveKind.call(this);
}
var CHAR_instance;
function CHAR_getInstance() {
  if (CHAR_instance == null)
    new CHAR();
  return CHAR_instance;
}
function SHORT() {
  SHORT_instance = this;
  PrimitiveKind.call(this);
}
var SHORT_instance;
function SHORT_getInstance() {
  if (SHORT_instance == null)
    new SHORT();
  return SHORT_instance;
}
function INT() {
  INT_instance = this;
  PrimitiveKind.call(this);
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance == null)
    new INT();
  return INT_instance;
}
function LONG() {
  LONG_instance = this;
  PrimitiveKind.call(this);
}
var LONG_instance;
function LONG_getInstance() {
  if (LONG_instance == null)
    new LONG();
  return LONG_instance;
}
function FLOAT() {
  FLOAT_instance = this;
  PrimitiveKind.call(this);
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance == null)
    new FLOAT();
  return FLOAT_instance;
}
function DOUBLE() {
  DOUBLE_instance = this;
  PrimitiveKind.call(this);
}
var DOUBLE_instance;
function DOUBLE_getInstance() {
  if (DOUBLE_instance == null)
    new DOUBLE();
  return DOUBLE_instance;
}
function STRING() {
  STRING_instance = this;
  PrimitiveKind.call(this);
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance == null)
    new STRING();
  return STRING_instance;
}
function PrimitiveKind() {
  SerialKind.call(this);
}
function SEALED() {
  SEALED_instance = this;
  PolymorphicKind.call(this);
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance == null)
    new SEALED();
  return SEALED_instance;
}
function OPEN() {
  OPEN_instance = this;
  PolymorphicKind.call(this);
}
var OPEN_instance;
function OPEN_getInstance() {
  if (OPEN_instance == null)
    new OPEN();
  return OPEN_instance;
}
function PolymorphicKind() {
  SerialKind.call(this);
}
function AbstractDecoder() {
}
protoOf(AbstractDecoder).rh = function () {
  throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
};
protoOf(AbstractDecoder).sh = function () {
  return true;
};
protoOf(AbstractDecoder).th = function () {
  return null;
};
protoOf(AbstractDecoder).uh = function () {
  var tmp = this.rh();
  return typeof tmp === 'boolean' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).vh = function () {
  var tmp = this.rh();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).wh = function () {
  var tmp = this.rh();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).xh = function () {
  var tmp = this.rh();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).yh = function () {
  var tmp = this.rh();
  return tmp instanceof Long ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).zh = function () {
  var tmp = this.rh();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).ai = function () {
  var tmp = this.rh();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).bi = function () {
  var tmp = this.rh();
  return tmp instanceof Char ? tmp.x_1 : THROW_CCE();
};
protoOf(AbstractDecoder).ci = function () {
  var tmp = this.rh();
  return typeof tmp === 'string' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).di = function (descriptor) {
  return this;
};
protoOf(AbstractDecoder).ei = function (deserializer, previousValue) {
  return this.fi(deserializer);
};
protoOf(AbstractDecoder).gi = function (descriptor) {
  return this;
};
protoOf(AbstractDecoder).hi = function (descriptor) {
};
protoOf(AbstractDecoder).ii = function (descriptor, index) {
  return this.uh();
};
protoOf(AbstractDecoder).ji = function (descriptor, index) {
  return this.vh();
};
protoOf(AbstractDecoder).ki = function (descriptor, index) {
  return this.wh();
};
protoOf(AbstractDecoder).li = function (descriptor, index) {
  return this.xh();
};
protoOf(AbstractDecoder).mi = function (descriptor, index) {
  return this.yh();
};
protoOf(AbstractDecoder).ni = function (descriptor, index) {
  return this.zh();
};
protoOf(AbstractDecoder).oi = function (descriptor, index) {
  return this.ai();
};
protoOf(AbstractDecoder).pi = function (descriptor, index) {
  return this.bi();
};
protoOf(AbstractDecoder).qi = function (descriptor, index) {
  return this.ci();
};
protoOf(AbstractDecoder).ri = function (descriptor, index) {
  return this.di(descriptor.vg(index));
};
protoOf(AbstractDecoder).si = function (descriptor, index, deserializer, previousValue) {
  return this.ei(deserializer, previousValue);
};
function AbstractEncoder() {
}
protoOf(AbstractEncoder).gi = function (descriptor) {
  return this;
};
protoOf(AbstractEncoder).hi = function (descriptor) {
};
protoOf(AbstractEncoder).yi = function (descriptor, index) {
  return true;
};
protoOf(AbstractEncoder).zi = function (value) {
  throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
};
protoOf(AbstractEncoder).aj = function () {
  throw SerializationException_init_$Create$_0("'null' is not supported by default");
};
protoOf(AbstractEncoder).bj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).cj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).dj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).ej = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).fj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).gj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).hj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).ij = function (value) {
  return this.zi(new Char(value));
};
protoOf(AbstractEncoder).jj = function (value) {
  return this.zi(value);
};
protoOf(AbstractEncoder).kj = function (descriptor) {
  return this;
};
protoOf(AbstractEncoder).lj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.bj(value);
  }
};
protoOf(AbstractEncoder).mj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.cj(value);
  }
};
protoOf(AbstractEncoder).nj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.dj(value);
  }
};
protoOf(AbstractEncoder).oj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.ej(value);
  }
};
protoOf(AbstractEncoder).pj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.fj(value);
  }
};
protoOf(AbstractEncoder).qj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.gj(value);
  }
};
protoOf(AbstractEncoder).rj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.hj(value);
  }
};
protoOf(AbstractEncoder).sj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.ij(value);
  }
};
protoOf(AbstractEncoder).tj = function (descriptor, index, value) {
  if (this.yi(descriptor, index)) {
    this.jj(value);
  }
};
protoOf(AbstractEncoder).uj = function (descriptor, index) {
  return this.yi(descriptor, index) ? this.kj(descriptor.vg(index)) : NoOpEncoder_getInstance();
};
protoOf(AbstractEncoder).vj = function (descriptor, index, serializer, value) {
  if (this.yi(descriptor, index)) {
    this.wj(serializer, value);
  }
};
function Decoder() {
}
function CompositeDecoder() {
}
function Encoder() {
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.qi($this.jf(), 0);
  var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
  return compositeDecoder.ti($this.jf(), 1, serializer);
}
function AbstractPolymorphicSerializer() {
}
protoOf(AbstractPolymorphicSerializer).zf = function (encoder, value) {
  var actualSerializer = findPolymorphicSerializer(this, encoder, value);
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.jf();
  var composite = encoder.gi(descriptor);
  composite.tj(this.jf(), 0, actualSerializer.jf().ng());
  var tmp = this.jf();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
  composite.vj(tmp, 1, tmp$ret$0, value);
  composite.hi(descriptor);
};
protoOf(AbstractPolymorphicSerializer).kf = function (encoder, value) {
  return this.zf(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(AbstractPolymorphicSerializer).lf = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.jf();
  var composite = decoder.gi(descriptor);
  var tmp$ret$0;
  $l$block: {
    var klassName = null;
    var value = null;
    if (composite.vi()) {
      tmp$ret$0 = decodeSequentially_0(this, composite);
      break $l$block;
    }
    mainLoop: while (true) {
      var index = composite.wi(this.jf());
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          klassName = composite.qi(this.jf(), index);
          break;
        case 1:
          var tmp0 = klassName;
          var tmp$ret$2;
          $l$block_0: {
            // Inline function 'kotlin.requireNotNull' call
            if (tmp0 == null) {
              var message = 'Cannot read polymorphic value before its type token';
              throw IllegalArgumentException_init_$Create$(toString(message));
            } else {
              tmp$ret$2 = tmp0;
              break $l$block_0;
            }
          }

          klassName = tmp$ret$2;
          var serializer = findPolymorphicSerializer_0(this, composite, klassName);
          value = composite.ti(this.jf(), index, serializer);
          break;
        default:
          var tmp0_elvis_lhs = klassName;
          throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
      }
    }
    var tmp0_0 = value;
    var tmp$ret$4;
    $l$block_1: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0_0 == null) {
        var message_0 = 'Polymorphic value has not been read for class ' + klassName;
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      } else {
        tmp$ret$4 = tmp0_0;
        break $l$block_1;
      }
    }
    var tmp = tmp$ret$4;
    tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
  }
  var result = tmp$ret$0;
  composite.hi(descriptor);
  return result;
};
protoOf(AbstractPolymorphicSerializer).ag = function (decoder, klassName) {
  return decoder.ui().zj(this.yf(), klassName);
};
protoOf(AbstractPolymorphicSerializer).bg = function (encoder, value) {
  return encoder.ui().ak(this.yf(), value);
};
function throwSubtypeNotRegistered(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.v7();
  throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
function throwSubtypeNotRegistered_0(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.v7() + "'";
  throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.v7() + "' has to be sealed and '@Serializable'."));
}
function NothingSerializer_0() {
  NothingSerializer_instance = this;
  this.bk_1 = NothingSerialDescriptor_getInstance();
}
protoOf(NothingSerializer_0).jf = function () {
  return this.bk_1;
};
protoOf(NothingSerializer_0).ck = function (encoder, value) {
  throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
};
protoOf(NothingSerializer_0).kf = function (encoder, value) {
  var tmp;
  if (false) {
    tmp = value;
  } else {
    tmp = THROW_CCE();
  }
  return this.ck(encoder, tmp);
};
protoOf(NothingSerializer_0).lf = function (decoder) {
  throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
};
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance == null)
    new NothingSerializer_0();
  return NothingSerializer_instance;
}
function DurationSerializer() {
  DurationSerializer_instance = this;
  this.dk_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
}
protoOf(DurationSerializer).jf = function () {
  return this.dk_1;
};
protoOf(DurationSerializer).ek = function (encoder, value) {
  encoder.jj(Duration__toIsoString_impl_9h6wsm(value));
};
protoOf(DurationSerializer).kf = function (encoder, value) {
  return this.ek(encoder, value instanceof Duration ? value.yc_1 : THROW_CCE());
};
protoOf(DurationSerializer).fk = function (decoder) {
  return Companion_getInstance().xc(decoder.ci());
};
protoOf(DurationSerializer).lf = function (decoder) {
  return new Duration(this.fk(decoder));
};
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance == null)
    new DurationSerializer();
  return DurationSerializer_instance;
}
function UuidSerializer() {
  UuidSerializer_instance = this;
  this.gk_1 = new PrimitiveSerialDescriptor_0('kotlin.uuid.Uuid', STRING_getInstance());
}
protoOf(UuidSerializer).jf = function () {
  return this.gk_1;
};
protoOf(UuidSerializer).hk = function (encoder, value) {
  encoder.jj(value.toString());
};
protoOf(UuidSerializer).kf = function (encoder, value) {
  return this.hk(encoder, value instanceof Uuid ? value : THROW_CCE());
};
protoOf(UuidSerializer).lf = function (decoder) {
  return Companion_getInstance_0().qd(decoder.ci());
};
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance == null)
    new UuidSerializer();
  return UuidSerializer_instance;
}
function CachedNames() {
}
function ArrayListClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(ArrayListClassDesc).ng = function () {
  return 'kotlin.collections.ArrayList';
};
function HashSetClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(HashSetClassDesc).ng = function () {
  return 'kotlin.collections.HashSet';
};
function LinkedHashSetClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(LinkedHashSetClassDesc).ng = function () {
  return 'kotlin.collections.LinkedHashSet';
};
function HashMapClassDesc(keyDesc, valueDesc) {
  MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
}
function LinkedHashMapClassDesc(keyDesc, valueDesc) {
  MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
}
function ArrayClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(ArrayClassDesc).ng = function () {
  return 'kotlin.Array';
};
function ListLikeDescriptor(elementDescriptor) {
  this.kk_1 = elementDescriptor;
  this.lk_1 = 1;
}
protoOf(ListLikeDescriptor).og = function () {
  return LIST_getInstance();
};
protoOf(ListLikeDescriptor).qg = function () {
  return this.lk_1;
};
protoOf(ListLikeDescriptor).sg = function (index) {
  return index.toString();
};
protoOf(ListLikeDescriptor).tg = function (name) {
  var tmp0_elvis_lhs = toIntOrNull(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(ListLikeDescriptor).wg = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.ng() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return false;
};
protoOf(ListLikeDescriptor).ug = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.ng() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return emptyList();
};
protoOf(ListLikeDescriptor).vg = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.ng() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.kk_1;
};
protoOf(ListLikeDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ListLikeDescriptor))
    return false;
  if (equals(this.kk_1, other.kk_1) && this.ng() === other.ng())
    return true;
  return false;
};
protoOf(ListLikeDescriptor).hashCode = function () {
  return imul(hashCode(this.kk_1), 31) + getStringHashCode(this.ng()) | 0;
};
protoOf(ListLikeDescriptor).toString = function () {
  return this.ng() + '(' + toString(this.kk_1) + ')';
};
function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
  this.qk_1 = serialName;
  this.rk_1 = keyDescriptor;
  this.sk_1 = valueDescriptor;
  this.tk_1 = 2;
}
protoOf(MapLikeDescriptor).ng = function () {
  return this.qk_1;
};
protoOf(MapLikeDescriptor).og = function () {
  return MAP_getInstance();
};
protoOf(MapLikeDescriptor).qg = function () {
  return this.tk_1;
};
protoOf(MapLikeDescriptor).sg = function (index) {
  return index.toString();
};
protoOf(MapLikeDescriptor).tg = function (name) {
  var tmp0_elvis_lhs = toIntOrNull(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(MapLikeDescriptor).wg = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.ng() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return false;
};
protoOf(MapLikeDescriptor).ug = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.ng() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return emptyList();
};
protoOf(MapLikeDescriptor).vg = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.ng() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  switch (index % 2 | 0) {
    case 0:
      tmp = this.rk_1;
      break;
    case 1:
      tmp = this.sk_1;
      break;
    default:
      var message_0 = 'Unreached';
      throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return tmp;
};
protoOf(MapLikeDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MapLikeDescriptor))
    return false;
  if (!(this.ng() === other.ng()))
    return false;
  if (!equals(this.rk_1, other.rk_1))
    return false;
  if (!equals(this.sk_1, other.sk_1))
    return false;
  return true;
};
protoOf(MapLikeDescriptor).hashCode = function () {
  var result = getStringHashCode(this.ng());
  result = imul(31, result) + hashCode(this.rk_1) | 0;
  result = imul(31, result) + hashCode(this.sk_1) | 0;
  return result;
};
protoOf(MapLikeDescriptor).toString = function () {
  return this.ng() + '(' + toString(this.rk_1) + ', ' + toString(this.sk_1) + ')';
};
function PrimitiveArrayDescriptor(primitive) {
  ListLikeDescriptor.call(this, primitive);
  this.yk_1 = primitive.ng() + 'Array';
}
protoOf(PrimitiveArrayDescriptor).ng = function () {
  return this.yk_1;
};
function ArrayListSerializer(element) {
  CollectionSerializer.call(this, element);
  this.al_1 = new ArrayListClassDesc(element.jf());
}
protoOf(ArrayListSerializer).jf = function () {
  return this.al_1;
};
protoOf(ArrayListSerializer).bl = function () {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
};
protoOf(ArrayListSerializer).cl = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(ArrayListSerializer).dl = function (_this__u8e3s4) {
  return this.cl(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).el = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(ArrayListSerializer).fl = function (_this__u8e3s4) {
  return this.el(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).gl = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(ArrayListSerializer).hl = function (_this__u8e3s4) {
  return this.gl((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).il = function (_this__u8e3s4, size) {
  return _this__u8e3s4.s3(size);
};
protoOf(ArrayListSerializer).jl = function (_this__u8e3s4, size) {
  return this.il(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(ArrayListSerializer).kl = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.z2(index, element);
};
protoOf(ArrayListSerializer).ll = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
  return this.kl(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function HashSetSerializer(eSerializer) {
  CollectionSerializer.call(this, eSerializer);
  this.wl_1 = new HashSetClassDesc(eSerializer.jf());
}
protoOf(HashSetSerializer).jf = function () {
  return this.wl_1;
};
protoOf(HashSetSerializer).bl = function () {
  return HashSet_init_$Create$();
};
protoOf(HashSetSerializer).xl = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(HashSetSerializer).dl = function (_this__u8e3s4) {
  return this.xl(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).yl = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(HashSetSerializer).fl = function (_this__u8e3s4) {
  return this.yl(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).zl = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(HashSetSerializer).hl = function (_this__u8e3s4) {
  return this.zl((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).am = function (_this__u8e3s4, size) {
};
protoOf(HashSetSerializer).jl = function (_this__u8e3s4, size) {
  return this.am(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(HashSetSerializer).bm = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.f(element);
};
protoOf(HashSetSerializer).ll = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
  return this.bm(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function LinkedHashSetSerializer(eSerializer) {
  CollectionSerializer.call(this, eSerializer);
  this.dm_1 = new LinkedHashSetClassDesc(eSerializer.jf());
}
protoOf(LinkedHashSetSerializer).jf = function () {
  return this.dm_1;
};
protoOf(LinkedHashSetSerializer).bl = function () {
  // Inline function 'kotlin.collections.linkedSetOf' call
  return LinkedHashSet_init_$Create$();
};
protoOf(LinkedHashSetSerializer).em = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(LinkedHashSetSerializer).dl = function (_this__u8e3s4) {
  return this.em(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).fm = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(LinkedHashSetSerializer).fl = function (_this__u8e3s4) {
  return this.fm(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).zl = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(LinkedHashSetSerializer).hl = function (_this__u8e3s4) {
  return this.zl((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).gm = function (_this__u8e3s4, size) {
};
protoOf(LinkedHashSetSerializer).jl = function (_this__u8e3s4, size) {
  return this.gm(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(LinkedHashSetSerializer).hm = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.f(element);
};
protoOf(LinkedHashSetSerializer).ll = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
  return this.hm(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function HashMapSerializer(kSerializer, vSerializer) {
  MapLikeSerializer.call(this, kSerializer, vSerializer);
  this.km_1 = new HashMapClassDesc(kSerializer.jf(), vSerializer.jf());
}
protoOf(HashMapSerializer).jf = function () {
  return this.km_1;
};
protoOf(HashMapSerializer).lm = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(HashMapSerializer).mm = function (_this__u8e3s4) {
  return this.lm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).nm = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.iterator' call
  return _this__u8e3s4.t1().h();
};
protoOf(HashMapSerializer).om = function (_this__u8e3s4) {
  return this.nm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).bl = function () {
  return HashMap_init_$Create$();
};
protoOf(HashMapSerializer).pm = function (_this__u8e3s4) {
  return imul(_this__u8e3s4.k(), 2);
};
protoOf(HashMapSerializer).dl = function (_this__u8e3s4) {
  return this.pm(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).qm = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(HashMapSerializer).fl = function (_this__u8e3s4) {
  return this.qm(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).rm = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(HashMapSerializer).hl = function (_this__u8e3s4) {
  return this.rm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).sm = function (_this__u8e3s4, size) {
};
protoOf(HashMapSerializer).jl = function (_this__u8e3s4, size) {
  return this.sm(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
};
function LinkedHashMapSerializer(kSerializer, vSerializer) {
  MapLikeSerializer.call(this, kSerializer, vSerializer);
  this.zm_1 = new LinkedHashMapClassDesc(kSerializer.jf(), vSerializer.jf());
}
protoOf(LinkedHashMapSerializer).jf = function () {
  return this.zm_1;
};
protoOf(LinkedHashMapSerializer).lm = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(LinkedHashMapSerializer).mm = function (_this__u8e3s4) {
  return this.lm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).nm = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.iterator' call
  return _this__u8e3s4.t1().h();
};
protoOf(LinkedHashMapSerializer).om = function (_this__u8e3s4) {
  return this.nm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).bl = function () {
  return LinkedHashMap_init_$Create$();
};
protoOf(LinkedHashMapSerializer).an = function (_this__u8e3s4) {
  return imul(_this__u8e3s4.k(), 2);
};
protoOf(LinkedHashMapSerializer).dl = function (_this__u8e3s4) {
  return this.an(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).bn = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(LinkedHashMapSerializer).fl = function (_this__u8e3s4) {
  return this.bn(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).rm = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(LinkedHashMapSerializer).hl = function (_this__u8e3s4) {
  return this.rm((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).cn = function (_this__u8e3s4, size) {
};
protoOf(LinkedHashMapSerializer).jl = function (_this__u8e3s4, size) {
  return this.cn(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
};
function ReferenceArraySerializer(kClass, eSerializer) {
  CollectionLikeSerializer.call(this, eSerializer);
  this.en_1 = kClass;
  this.fn_1 = new ArrayClassDesc(eSerializer.jf());
}
protoOf(ReferenceArraySerializer).jf = function () {
  return this.fn_1;
};
protoOf(ReferenceArraySerializer).gn = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ReferenceArraySerializer).mm = function (_this__u8e3s4) {
  return this.gn((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).hn = function (_this__u8e3s4) {
  return arrayIterator(_this__u8e3s4);
};
protoOf(ReferenceArraySerializer).om = function (_this__u8e3s4) {
  return this.hn((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).bl = function () {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
};
protoOf(ReferenceArraySerializer).in = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(ReferenceArraySerializer).dl = function (_this__u8e3s4) {
  return this.in(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).jn = function (_this__u8e3s4) {
  return toNativeArrayImpl(_this__u8e3s4, this.en_1);
};
protoOf(ReferenceArraySerializer).fl = function (_this__u8e3s4) {
  return this.jn(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).kn = function (_this__u8e3s4) {
  return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
};
protoOf(ReferenceArraySerializer).hl = function (_this__u8e3s4) {
  return this.kn((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).ln = function (_this__u8e3s4, size) {
  return _this__u8e3s4.s3(size);
};
protoOf(ReferenceArraySerializer).jl = function (_this__u8e3s4, size) {
  return this.ln(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(ReferenceArraySerializer).mn = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.z2(index, element);
};
protoOf(ReferenceArraySerializer).ll = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
  return this.mn(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function CollectionSerializer(element) {
  CollectionLikeSerializer.call(this, element);
}
protoOf(CollectionSerializer).nl = function (_this__u8e3s4) {
  return _this__u8e3s4.k();
};
protoOf(CollectionSerializer).mm = function (_this__u8e3s4) {
  return this.nl((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CollectionSerializer).ol = function (_this__u8e3s4) {
  return _this__u8e3s4.h();
};
protoOf(CollectionSerializer).om = function (_this__u8e3s4) {
  return this.ol((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
};
function MapLikeSerializer(keySerializer, valueSerializer) {
  AbstractCollectionSerializer.call(this);
  this.tm_1 = keySerializer;
  this.um_1 = valueSerializer;
}
protoOf(MapLikeSerializer).vm = function (decoder, builder, startIndex, size) {
  // Inline function 'kotlin.require' call
  if (!(size >= 0)) {
    var message = 'Size must be known in advance when using READ_ALL';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var progression = step(until(0, imul(size, 2)), 2);
  var inductionVariable = progression.o_1;
  var last = progression.p_1;
  var step_0 = progression.q_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      this.wm(decoder, startIndex + index | 0, builder, false);
    }
     while (!(index === last));
};
protoOf(MapLikeSerializer).rl = function (decoder, builder, startIndex, size) {
  return this.vm(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
};
protoOf(MapLikeSerializer).wm = function (decoder, index, builder, checkIndex) {
  var key = decoder.ti(this.jf(), index, this.tm_1);
  var tmp;
  if (checkIndex) {
    // Inline function 'kotlin.also' call
    var this_0 = decoder.wi(this.jf());
    // Inline function 'kotlin.require' call
    if (!(this_0 === (index + 1 | 0))) {
      var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    tmp = this_0;
  } else {
    tmp = index + 1 | 0;
  }
  var vIndex = tmp;
  var tmp_0;
  var tmp_1;
  if (builder.o1(key)) {
    var tmp_2 = this.um_1.jf().og();
    tmp_1 = !(tmp_2 instanceof PrimitiveKind);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = decoder.si(this.jf(), vIndex, this.um_1, getValue(builder, key));
  } else {
    tmp_0 = decoder.ti(this.jf(), vIndex, this.um_1);
  }
  var value = tmp_0;
  // Inline function 'kotlin.collections.set' call
  builder.u1(key, value);
};
protoOf(MapLikeSerializer).sl = function (decoder, index, builder, checkIndex) {
  return this.wm(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
};
protoOf(MapLikeSerializer).ql = function (encoder, value) {
  var size = this.mm(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.jf();
  var composite = encoder.yj(descriptor, size);
  var iterator = this.om(value);
  var index = 0;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = iterator;
  while (_iterator__ex2g4s.i()) {
    var element = _iterator__ex2g4s.j();
    // Inline function 'kotlin.collections.component1' call
    var k = element.m1();
    // Inline function 'kotlin.collections.component2' call
    var v = element.n1();
    var tmp = this.jf();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    composite.vj(tmp, _unary__edvuaz, this.tm_1, k);
    var tmp_0 = this.jf();
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    composite.vj(tmp_0, _unary__edvuaz_0, this.um_1, v);
  }
  composite.hi(descriptor);
};
protoOf(MapLikeSerializer).kf = function (encoder, value) {
  return this.ql(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
function CollectionLikeSerializer(elementSerializer) {
  AbstractCollectionSerializer.call(this);
  this.pl_1 = elementSerializer;
}
protoOf(CollectionLikeSerializer).ql = function (encoder, value) {
  var size = this.mm(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.jf();
  var composite = encoder.yj(descriptor, size);
  var iterator = this.om(value);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      composite.vj(this.jf(), index, this.pl_1, iterator.j());
    }
     while (inductionVariable < size);
  composite.hi(descriptor);
};
protoOf(CollectionLikeSerializer).kf = function (encoder, value) {
  return this.ql(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(CollectionLikeSerializer).rl = function (decoder, builder, startIndex, size) {
  // Inline function 'kotlin.require' call
  if (!(size >= 0)) {
    var message = 'Size must be known in advance when using READ_ALL';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.sl(decoder, startIndex + index | 0, builder, false);
    }
     while (inductionVariable < size);
};
protoOf(CollectionLikeSerializer).sl = function (decoder, index, builder, checkIndex) {
  this.ll(builder, index, decoder.ti(this.jf(), index, this.pl_1));
};
function readSize($this, decoder, builder) {
  var size = decoder.xi($this.jf());
  $this.jl(builder, size);
  return size;
}
function AbstractCollectionSerializer() {
}
protoOf(AbstractCollectionSerializer).ul = function (decoder, previous) {
  var tmp1_elvis_lhs = previous == null ? null : this.hl(previous);
  var builder = tmp1_elvis_lhs == null ? this.bl() : tmp1_elvis_lhs;
  var startIndex = this.dl(builder);
  var compositeDecoder = decoder.gi(this.jf());
  if (compositeDecoder.vi()) {
    this.rl(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
  } else {
    $l$loop: while (true) {
      var index = compositeDecoder.wi(this.jf());
      if (index === -1)
        break $l$loop;
      this.tl(compositeDecoder, startIndex + index | 0, builder);
    }
  }
  compositeDecoder.hi(this.jf());
  return this.fl(builder);
};
protoOf(AbstractCollectionSerializer).lf = function (decoder) {
  return this.ul(decoder, null);
};
protoOf(AbstractCollectionSerializer).tl = function (decoder, index, builder, checkIndex, $super) {
  checkIndex = checkIndex === VOID ? true : checkIndex;
  var tmp;
  if ($super === VOID) {
    this.sl(decoder, index, builder, checkIndex);
    tmp = Unit_instance;
  } else {
    tmp = $super.sl.call(this, decoder, index, builder, checkIndex);
  }
  return tmp;
};
function PrimitiveArraySerializer(primitiveSerializer) {
  CollectionLikeSerializer.call(this, primitiveSerializer);
  this.on_1 = new PrimitiveArrayDescriptor(primitiveSerializer.jf());
}
protoOf(PrimitiveArraySerializer).jf = function () {
  return this.on_1;
};
protoOf(PrimitiveArraySerializer).pn = function (_this__u8e3s4) {
  return _this__u8e3s4.qn();
};
protoOf(PrimitiveArraySerializer).dl = function (_this__u8e3s4) {
  return this.pn(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).rn = function (_this__u8e3s4) {
  return _this__u8e3s4.sn();
};
protoOf(PrimitiveArraySerializer).fl = function (_this__u8e3s4) {
  return this.rn(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).tn = function (_this__u8e3s4, size) {
  return _this__u8e3s4.un(size);
};
protoOf(PrimitiveArraySerializer).jl = function (_this__u8e3s4, size) {
  return this.tn(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(PrimitiveArraySerializer).vn = function (_this__u8e3s4) {
  var message = 'This method lead to boxing and must not be used, use writeContents instead';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(PrimitiveArraySerializer).om = function (_this__u8e3s4) {
  return this.vn((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).wn = function (_this__u8e3s4, index, element) {
  var message = 'This method lead to boxing and must not be used, use Builder.append instead';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(PrimitiveArraySerializer).ll = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
  return this.wn(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).bl = function () {
  return this.hl(this.xn());
};
protoOf(PrimitiveArraySerializer).ao = function (encoder, value) {
  var size = this.mm(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.on_1;
  var composite = encoder.yj(descriptor, size);
  this.zn(composite, value, size);
  composite.hi(descriptor);
};
protoOf(PrimitiveArraySerializer).kf = function (encoder, value) {
  return this.ao(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).ql = function (encoder, value) {
  return this.ao(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).lf = function (decoder) {
  return this.ul(decoder, null);
};
function PrimitiveArrayBuilder() {
}
protoOf(PrimitiveArrayBuilder).bo = function (requiredCapacity, $super) {
  requiredCapacity = requiredCapacity === VOID ? this.qn() + 1 | 0 : requiredCapacity;
  var tmp;
  if ($super === VOID) {
    this.un(requiredCapacity);
    tmp = Unit_instance;
  } else {
    tmp = $super.un.call(this, requiredCapacity);
  }
  return tmp;
};
function Companion() {
  Companion_instance_0 = this;
  this.co_1 = longArray(0);
}
var Companion_instance_0;
function Companion_getInstance_7() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = shiftLeft(new Long(-1, -1), elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.go_1[slot] = bitwiseOr($this.go_1[slot], shiftLeft(new Long(1, 0), offsetInSlot));
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.go_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.go_1[slot];
      while (!equalsLong(slotMarks, new Long(-1, -1))) {
        var indexInSlot = countTrailingZeroBits(invert(slotMarks));
        slotMarks = bitwiseOr(slotMarks, shiftLeft(new Long(1, 0), indexInSlot));
        var index = slotOffset + indexInSlot | 0;
        if ($this.eo_1($this.do_1, index)) {
          $this.go_1[slot] = slotMarks;
          return index;
        }
      }
      $this.go_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function ElementMarker(descriptor, readIfAbsent) {
  Companion_getInstance_7();
  this.do_1 = descriptor;
  this.eo_1 = readIfAbsent;
  var elementsCount = this.do_1.qg();
  if (elementsCount <= 64) {
    var tmp = this;
    var tmp_0;
    if (elementsCount === 64) {
      tmp_0 = new Long(0, 0);
    } else {
      tmp_0 = shiftLeft(new Long(-1, -1), elementsCount);
    }
    tmp.fo_1 = tmp_0;
    this.go_1 = Companion_getInstance_7().co_1;
  } else {
    this.fo_1 = new Long(0, 0);
    this.go_1 = prepareHighMarksArray(this, elementsCount);
  }
}
protoOf(ElementMarker).ho = function (index) {
  if (index < 64) {
    this.fo_1 = bitwiseOr(this.fo_1, shiftLeft(new Long(1, 0), index));
  } else {
    markHigh(this, index);
  }
};
protoOf(ElementMarker).io = function () {
  var elementsCount = this.do_1.qg();
  while (!equalsLong(this.fo_1, new Long(-1, -1))) {
    var index = countTrailingZeroBits(invert(this.fo_1));
    this.fo_1 = bitwiseOr(this.fo_1, shiftLeft(new Long(1, 0), index));
    if (this.eo_1(this.do_1, index)) {
      return index;
    }
  }
  if (elementsCount > 64) {
    return nextUnmarkedHighIndex(this);
  }
  return -1;
};
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
}
function InlineClassDescriptor(name, generatedSerializer) {
  PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
  this.vo_1 = true;
}
protoOf(InlineClassDescriptor).pg = function () {
  return this.vo_1;
};
protoOf(InlineClassDescriptor).hashCode = function () {
  return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
};
protoOf(InlineClassDescriptor).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof InlineClassDescriptor)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.ng() === other.ng())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(other.vo_1 && contentEquals(this.ip(), other.ip()))) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.qg() === other.qg())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.qg();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.vg(index).ng() === other.vg(index).ng())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.vg(index).og(), other.vg(index).og())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
function InlinePrimitiveDescriptor$1($primitiveSerializer) {
  this.kp_1 = $primitiveSerializer;
}
protoOf(InlinePrimitiveDescriptor$1).lp = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [this.kp_1];
};
protoOf(InlinePrimitiveDescriptor$1).jf = function () {
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(InlinePrimitiveDescriptor$1).kf = function (encoder, value) {
  // Inline function 'kotlin.error' call
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(InlinePrimitiveDescriptor$1).lf = function (decoder) {
  // Inline function 'kotlin.error' call
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
function NoOpEncoder() {
  NoOpEncoder_instance = this;
  AbstractEncoder.call(this);
  this.np_1 = EmptySerializersModule_0();
}
protoOf(NoOpEncoder).ui = function () {
  return this.np_1;
};
protoOf(NoOpEncoder).zi = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).aj = function () {
  return Unit_instance;
};
protoOf(NoOpEncoder).bj = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).cj = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).dj = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ej = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).fj = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).gj = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).hj = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ij = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).jj = function (value) {
  return Unit_instance;
};
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance == null)
    new NoOpEncoder();
  return NoOpEncoder_instance;
}
function error($this) {
  throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
}
function NothingSerialDescriptor() {
  NothingSerialDescriptor_instance = this;
  this.op_1 = OBJECT_getInstance();
  this.pp_1 = 'kotlin.Nothing';
}
protoOf(NothingSerialDescriptor).og = function () {
  return this.op_1;
};
protoOf(NothingSerialDescriptor).ng = function () {
  return this.pp_1;
};
protoOf(NothingSerialDescriptor).qg = function () {
  return 0;
};
protoOf(NothingSerialDescriptor).sg = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).tg = function (name) {
  error(this);
};
protoOf(NothingSerialDescriptor).wg = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).vg = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).ug = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).toString = function () {
  return 'NothingSerialDescriptor';
};
protoOf(NothingSerialDescriptor).equals = function (other) {
  return this === other;
};
protoOf(NothingSerialDescriptor).hashCode = function () {
  return getStringHashCode(this.pp_1) + imul(31, this.op_1.hashCode()) | 0;
};
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance == null)
    new NothingSerialDescriptor();
  return NothingSerialDescriptor_instance;
}
function NullableSerializer(serializer) {
  this.qp_1 = serializer;
  this.rp_1 = new SerialDescriptorForNullable(this.qp_1.jf());
}
protoOf(NullableSerializer).jf = function () {
  return this.rp_1;
};
protoOf(NullableSerializer).sp = function (encoder, value) {
  if (!(value == null)) {
    encoder.xj();
    encoder.wj(this.qp_1, value);
  } else {
    encoder.aj();
  }
};
protoOf(NullableSerializer).kf = function (encoder, value) {
  return this.sp(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(NullableSerializer).lf = function (decoder) {
  return decoder.sh() ? decoder.fi(this.qp_1) : decoder.th();
};
protoOf(NullableSerializer).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof NullableSerializer))
    THROW_CCE();
  if (!equals(this.qp_1, other.qp_1))
    return false;
  return true;
};
protoOf(NullableSerializer).hashCode = function () {
  return hashCode(this.qp_1);
};
function SerialDescriptorForNullable(original) {
  this.xg_1 = original;
  this.yg_1 = this.xg_1.ng() + '?';
  this.zg_1 = cachedSerialNames(this.xg_1);
}
protoOf(SerialDescriptorForNullable).ng = function () {
  return this.yg_1;
};
protoOf(SerialDescriptorForNullable).qh = function () {
  return this.zg_1;
};
protoOf(SerialDescriptorForNullable).jg = function () {
  return true;
};
protoOf(SerialDescriptorForNullable).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SerialDescriptorForNullable))
    return false;
  if (!equals(this.xg_1, other.xg_1))
    return false;
  return true;
};
protoOf(SerialDescriptorForNullable).toString = function () {
  return toString(this.xg_1) + '?';
};
protoOf(SerialDescriptorForNullable).hashCode = function () {
  return imul(hashCode(this.xg_1), 31);
};
protoOf(SerialDescriptorForNullable).og = function () {
  return this.xg_1.og();
};
protoOf(SerialDescriptorForNullable).pg = function () {
  return this.xg_1.pg();
};
protoOf(SerialDescriptorForNullable).qg = function () {
  return this.xg_1.qg();
};
protoOf(SerialDescriptorForNullable).rg = function () {
  return this.xg_1.rg();
};
protoOf(SerialDescriptorForNullable).sg = function (index) {
  return this.xg_1.sg(index);
};
protoOf(SerialDescriptorForNullable).tg = function (name) {
  return this.xg_1.tg(name);
};
protoOf(SerialDescriptorForNullable).ug = function (index) {
  return this.xg_1.ug(index);
};
protoOf(SerialDescriptorForNullable).vg = function (index) {
  return this.xg_1.vg(index);
};
protoOf(SerialDescriptorForNullable).wg = function (index) {
  return this.xg_1.wg(index);
};
function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.of_1 = this$0.up_1;
    return Unit_instance;
  };
}
function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = OBJECT_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
  return function (p0) {
    return p0.jf();
  };
}
function ObjectSerializer(serialName, objectInstance) {
  this.tp_1 = objectInstance;
  this.up_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.vp_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
}
protoOf(ObjectSerializer).jf = function () {
  var tmp0 = this.vp_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
  return tmp0.n1();
};
protoOf(ObjectSerializer).zf = function (encoder, value) {
  encoder.gi(this.jf()).hi(this.jf());
};
protoOf(ObjectSerializer).kf = function (encoder, value) {
  return this.zf(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(ObjectSerializer).lf = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.jf();
  var composite = decoder.gi(descriptor);
  var tmp$ret$0;
  $l$block_0: {
    if (composite.vi()) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    }
    var index = composite.wi(this.jf());
    if (index === -1) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    } else
      throw SerializationException_init_$Create$_0('Unexpected index ' + index);
  }
  var result = tmp$ret$0;
  composite.hi(descriptor);
  return this.tp_1;
};
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function cachedSerialNames(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  if (isInterface(_this__u8e3s4, CachedNames))
    return _this__u8e3s4.qh();
  var result = HashSet_init_$Create$_1(_this__u8e3s4.qg());
  var inductionVariable = 0;
  var last = _this__u8e3s4.qg();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = _this__u8e3s4.sg(i);
      result.f(element);
    }
     while (inductionVariable < last);
  return result;
}
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.l())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
}
function kclass(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var t = _this__u8e3s4.i8();
  var tmp;
  if (!(t == null) ? isInterface(t, KClass) : false) {
    tmp = t;
  } else {
    if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
      throw IllegalArgumentException_init_$Create$('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
    } else {
      throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + toString_0(t));
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
}
function typeOrThrow(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0 = _this__u8e3s4.mb_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.mb_1);
      throw IllegalArgumentException_init_$Create$(toString(message));
    } else {
      tmp$ret$1 = tmp0;
      break $l$block;
    }
  }
  return tmp$ret$1;
}
function notRegisteredMessage(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0_elvis_lhs = _this__u8e3s4.v7();
  return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
}
function notRegisteredMessage_0(className) {
  _init_properties_Platform_common_kt__3qzecs();
  return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList_init_$Create$_0();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.sg(i);
        missingFields.f(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException_init_$Create$(missingFields, descriptor.ng());
}
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.fp_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
  return tmp0.n1();
}
function _get__hashCode__tgwhef_0($this) {
  var tmp0 = $this.hp_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
  return tmp0.n1();
}
function buildIndices($this) {
  var indices = HashMap_init_$Create$();
  var inductionVariable = 0;
  var last = $this.ap_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.ap_1[i];
      indices.u1(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.xo_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lp();
    return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
  return function (p0) {
    return _get_childSerializers__7vnyfa(p0);
  };
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.xo_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mp();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0 = item.jf();
        destination.f(tmp$ret$0);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
  return function (p0) {
    return p0.ip();
  };
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.ip());
  };
}
function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
  return function (p0) {
    return _get__hashCode__tgwhef_0(p0);
  };
}
function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
  return function (i) {
    return this$0.sg(i) + ': ' + this$0.vg(i).ng();
  };
}
function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
  generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
  this.wo_1 = serialName;
  this.xo_1 = generatedSerializer;
  this.yo_1 = elementsCount;
  this.zo_1 = -1;
  var tmp = this;
  var tmp_0 = 0;
  var tmp_1 = this.yo_1;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    tmp_2[tmp_0] = '[UNINITIALIZED]';
    tmp_0 = tmp_0 + 1 | 0;
  }
  tmp.ap_1 = tmp_2;
  var tmp_3 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this.yo_1;
  tmp_3.bp_1 = Array(size);
  this.cp_1 = null;
  this.dp_1 = booleanArray(this.yo_1);
  this.ep_1 = emptyMap();
  var tmp_4 = this;
  var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_4.fp_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
  var tmp_6 = this;
  var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_6.gp_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
  var tmp_8 = this;
  var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_8.hp_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
}
protoOf(PluginGeneratedSerialDescriptor).ng = function () {
  return this.wo_1;
};
protoOf(PluginGeneratedSerialDescriptor).qg = function () {
  return this.yo_1;
};
protoOf(PluginGeneratedSerialDescriptor).og = function () {
  return CLASS_getInstance();
};
protoOf(PluginGeneratedSerialDescriptor).rg = function () {
  var tmp0_elvis_lhs = this.cp_1;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).qh = function () {
  return this.ep_1.r1();
};
protoOf(PluginGeneratedSerialDescriptor).ip = function () {
  var tmp0 = this.gp_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
  return tmp0.n1();
};
protoOf(PluginGeneratedSerialDescriptor).jp = function (name, isOptional) {
  this.zo_1 = this.zo_1 + 1 | 0;
  this.ap_1[this.zo_1] = name;
  this.dp_1[this.zo_1] = isOptional;
  this.bp_1[this.zo_1] = null;
  if (this.zo_1 === (this.yo_1 - 1 | 0)) {
    this.ep_1 = buildIndices(this);
  }
};
protoOf(PluginGeneratedSerialDescriptor).vg = function (index) {
  return getChecked(_get_childSerializers__7vnyfa(this), index).jf();
};
protoOf(PluginGeneratedSerialDescriptor).wg = function (index) {
  return getChecked_0(this.dp_1, index);
};
protoOf(PluginGeneratedSerialDescriptor).ug = function (index) {
  var tmp0_elvis_lhs = getChecked(this.bp_1, index);
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).sg = function (index) {
  return getChecked(this.ap_1, index);
};
protoOf(PluginGeneratedSerialDescriptor).tg = function (name) {
  var tmp0_elvis_lhs = this.ep_1.q1(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof PluginGeneratedSerialDescriptor)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.ng() === other.ng())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!contentEquals(this.ip(), other.ip())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.qg() === other.qg())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.qg();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.vg(index).ng() === other.vg(index).ng())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.vg(index).og(), other.vg(index).og())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
  return _get__hashCode__tgwhef_0(this);
};
protoOf(PluginGeneratedSerialDescriptor).toString = function () {
  var tmp = until(0, this.yo_1);
  var tmp_0 = this.ng() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
};
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.ng());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.h();
  while (_iterator__ex2g4s.i()) {
    var element = _iterator__ex2g4s.j();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.ng();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.h();
  while (_iterator__ex2g4s_0.i()) {
    var element_0 = _iterator__ex2g4s_0.j();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.og();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
function GeneratedSerializer() {
}
function SerializerFactory() {
}
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
function CharArraySerializer_0() {
  CharArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_9(Companion_getInstance_1()));
}
protoOf(CharArraySerializer_0).zp = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(CharArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.zp((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CharArraySerializer_0).aq = function (_this__u8e3s4) {
  return new CharArrayBuilder(_this__u8e3s4);
};
protoOf(CharArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.aq((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CharArraySerializer_0).xn = function () {
  return charArray(0);
};
protoOf(CharArraySerializer_0).bq = function (decoder, index, builder, checkIndex) {
  builder.eq(decoder.pi(this.on_1, index));
};
protoOf(CharArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.bq(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(CharArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.bq(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(CharArraySerializer_0).fq = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.sj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(CharArraySerializer_0).zn = function (encoder, content, size) {
  return this.fq(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
};
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance == null)
    new CharArraySerializer_0();
  return CharArraySerializer_instance;
}
function DoubleArraySerializer_0() {
  DoubleArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_10(DoubleCompanionObject_instance));
}
protoOf(DoubleArraySerializer_0).iq = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(DoubleArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.iq((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(DoubleArraySerializer_0).jq = function (_this__u8e3s4) {
  return new DoubleArrayBuilder(_this__u8e3s4);
};
protoOf(DoubleArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.jq((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(DoubleArraySerializer_0).xn = function () {
  return new Float64Array(0);
};
protoOf(DoubleArraySerializer_0).kq = function (decoder, index, builder, checkIndex) {
  builder.nq(decoder.oi(this.on_1, index));
};
protoOf(DoubleArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.kq(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(DoubleArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.kq(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(DoubleArraySerializer_0).oq = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.rj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(DoubleArraySerializer_0).zn = function (encoder, content, size) {
  return this.oq(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
};
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance == null)
    new DoubleArraySerializer_0();
  return DoubleArraySerializer_instance;
}
function FloatArraySerializer_0() {
  FloatArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_11(FloatCompanionObject_instance));
}
protoOf(FloatArraySerializer_0).rq = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(FloatArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.rq((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(FloatArraySerializer_0).sq = function (_this__u8e3s4) {
  return new FloatArrayBuilder(_this__u8e3s4);
};
protoOf(FloatArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.sq((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(FloatArraySerializer_0).xn = function () {
  return new Float32Array(0);
};
protoOf(FloatArraySerializer_0).tq = function (decoder, index, builder, checkIndex) {
  builder.wq(decoder.ni(this.on_1, index));
};
protoOf(FloatArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.tq(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(FloatArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.tq(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(FloatArraySerializer_0).xq = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.qj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(FloatArraySerializer_0).zn = function (encoder, content, size) {
  return this.xq(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
};
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance == null)
    new FloatArraySerializer_0();
  return FloatArraySerializer_instance;
}
function LongArraySerializer_0() {
  LongArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_2()));
}
protoOf(LongArraySerializer_0).ar = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(LongArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.ar((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LongArraySerializer_0).br = function (_this__u8e3s4) {
  return new LongArrayBuilder(_this__u8e3s4);
};
protoOf(LongArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.br((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LongArraySerializer_0).xn = function () {
  return longArray(0);
};
protoOf(LongArraySerializer_0).cr = function (decoder, index, builder, checkIndex) {
  builder.fr(decoder.mi(this.on_1, index));
};
protoOf(LongArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.cr(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(LongArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.cr(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(LongArraySerializer_0).gr = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.pj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(LongArraySerializer_0).zn = function (encoder, content, size) {
  return this.gr(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
};
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance == null)
    new LongArraySerializer_0();
  return LongArraySerializer_instance;
}
function ULongArraySerializer_0() {
  ULongArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_2(Companion_getInstance_3()));
}
protoOf(ULongArraySerializer_0).jr = function (_this__u8e3s4) {
  return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
};
protoOf(ULongArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.jr(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.ye_1 : THROW_CCE());
};
protoOf(ULongArraySerializer_0).kr = function (_this__u8e3s4) {
  return new ULongArrayBuilder(_this__u8e3s4);
};
protoOf(ULongArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.kr(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.ye_1 : THROW_CCE());
};
protoOf(ULongArraySerializer_0).lr = function () {
  return _ULongArray___init__impl__twm1l3(0);
};
protoOf(ULongArraySerializer_0).xn = function () {
  return new ULongArray(this.lr());
};
protoOf(ULongArraySerializer_0).mr = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toULong' call
  var this_0 = decoder.ri(this.on_1, index).yh();
  var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
  builder.pr(tmp$ret$0);
};
protoOf(ULongArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.mr(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ULongArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.mr(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ULongArraySerializer_0).qr = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.uj(this.on_1, i);
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = ULongArray__get_impl_pr71q9(content, i);
      var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
      tmp.fj(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(ULongArraySerializer_0).zn = function (encoder, content, size) {
  return this.qr(encoder, content instanceof ULongArray ? content.ye_1 : THROW_CCE(), size);
};
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance == null)
    new ULongArraySerializer_0();
  return ULongArraySerializer_instance;
}
function IntArraySerializer_0() {
  IntArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_5(IntCompanionObject_instance));
}
protoOf(IntArraySerializer_0).tr = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(IntArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.tr((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(IntArraySerializer_0).ur = function (_this__u8e3s4) {
  return new IntArrayBuilder(_this__u8e3s4);
};
protoOf(IntArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.ur((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(IntArraySerializer_0).xn = function () {
  return new Int32Array(0);
};
protoOf(IntArraySerializer_0).vr = function (decoder, index, builder, checkIndex) {
  builder.yr(decoder.li(this.on_1, index));
};
protoOf(IntArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.vr(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(IntArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.vr(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(IntArraySerializer_0).zr = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.oj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(IntArraySerializer_0).zn = function (encoder, content, size) {
  return this.zr(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
};
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance == null)
    new IntArraySerializer_0();
  return IntArraySerializer_instance;
}
function UIntArraySerializer_0() {
  UIntArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_1(Companion_getInstance_4()));
}
protoOf(UIntArraySerializer_0).cs = function (_this__u8e3s4) {
  return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
};
protoOf(UIntArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.cs(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.oe_1 : THROW_CCE());
};
protoOf(UIntArraySerializer_0).ds = function (_this__u8e3s4) {
  return new UIntArrayBuilder(_this__u8e3s4);
};
protoOf(UIntArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.ds(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.oe_1 : THROW_CCE());
};
protoOf(UIntArraySerializer_0).es = function () {
  return _UIntArray___init__impl__ghjpc6(0);
};
protoOf(UIntArraySerializer_0).xn = function () {
  return new UIntArray(this.es());
};
protoOf(UIntArraySerializer_0).fs = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUInt' call
  var this_0 = decoder.ri(this.on_1, index).xh();
  var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
  builder.is(tmp$ret$0);
};
protoOf(UIntArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.fs(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UIntArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.fs(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UIntArraySerializer_0).js = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.uj(this.on_1, i);
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = UIntArray__get_impl_gp5kza(content, i);
      var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
      tmp.ej(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UIntArraySerializer_0).zn = function (encoder, content, size) {
  return this.js(encoder, content instanceof UIntArray ? content.oe_1 : THROW_CCE(), size);
};
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance == null)
    new UIntArraySerializer_0();
  return UIntArraySerializer_instance;
}
function ShortArraySerializer_0() {
  ShortArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_8(ShortCompanionObject_instance));
}
protoOf(ShortArraySerializer_0).ms = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ShortArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.ms((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ShortArraySerializer_0).ns = function (_this__u8e3s4) {
  return new ShortArrayBuilder(_this__u8e3s4);
};
protoOf(ShortArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.ns((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ShortArraySerializer_0).xn = function () {
  return new Int16Array(0);
};
protoOf(ShortArraySerializer_0).os = function (decoder, index, builder, checkIndex) {
  builder.rs(decoder.ki(this.on_1, index));
};
protoOf(ShortArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.os(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ShortArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.os(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ShortArraySerializer_0).ss = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.nj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(ShortArraySerializer_0).zn = function (encoder, content, size) {
  return this.ss(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
};
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance == null)
    new ShortArraySerializer_0();
  return ShortArraySerializer_instance;
}
function UShortArraySerializer_0() {
  UShortArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance_5()));
}
protoOf(UShortArraySerializer_0).vs = function (_this__u8e3s4) {
  return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
};
protoOf(UShortArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.vs(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.if_1 : THROW_CCE());
};
protoOf(UShortArraySerializer_0).ws = function (_this__u8e3s4) {
  return new UShortArrayBuilder(_this__u8e3s4);
};
protoOf(UShortArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.ws(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.if_1 : THROW_CCE());
};
protoOf(UShortArraySerializer_0).xs = function () {
  return _UShortArray___init__impl__9b26ef(0);
};
protoOf(UShortArraySerializer_0).xn = function () {
  return new UShortArray(this.xs());
};
protoOf(UShortArraySerializer_0).ys = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = decoder.ri(this.on_1, index).wh();
  var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
  builder.bt(tmp$ret$0);
};
protoOf(UShortArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.ys(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UShortArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.ys(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UShortArraySerializer_0).ct = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.uj(this.on_1, i);
      // Inline function 'kotlin.UShort.toShort' call
      var this_0 = UShortArray__get_impl_fnbhmx(content, i);
      var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
      tmp.dj(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UShortArraySerializer_0).zn = function (encoder, content, size) {
  return this.ct(encoder, content instanceof UShortArray ? content.if_1 : THROW_CCE(), size);
};
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance == null)
    new UShortArraySerializer_0();
  return UShortArraySerializer_instance;
}
function ByteArraySerializer_0() {
  ByteArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_7(ByteCompanionObject_instance));
}
protoOf(ByteArraySerializer_0).ft = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ByteArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.ft((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ByteArraySerializer_0).gt = function (_this__u8e3s4) {
  return new ByteArrayBuilder(_this__u8e3s4);
};
protoOf(ByteArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.gt((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ByteArraySerializer_0).xn = function () {
  return new Int8Array(0);
};
protoOf(ByteArraySerializer_0).ht = function (decoder, index, builder, checkIndex) {
  builder.kt(decoder.ji(this.on_1, index));
};
protoOf(ByteArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.ht(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ByteArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.ht(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ByteArraySerializer_0).lt = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.mj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(ByteArraySerializer_0).zn = function (encoder, content, size) {
  return this.lt(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
};
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance == null)
    new ByteArraySerializer_0();
  return ByteArraySerializer_instance;
}
function UByteArraySerializer_0() {
  UByteArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_3(Companion_getInstance_6()));
}
protoOf(UByteArraySerializer_0).ot = function (_this__u8e3s4) {
  return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
};
protoOf(UByteArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.ot(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ee_1 : THROW_CCE());
};
protoOf(UByteArraySerializer_0).pt = function (_this__u8e3s4) {
  return new UByteArrayBuilder(_this__u8e3s4);
};
protoOf(UByteArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.pt(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ee_1 : THROW_CCE());
};
protoOf(UByteArraySerializer_0).qt = function () {
  return _UByteArray___init__impl__ip4y9n(0);
};
protoOf(UByteArraySerializer_0).xn = function () {
  return new UByteArray(this.qt());
};
protoOf(UByteArraySerializer_0).rt = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = decoder.ri(this.on_1, index).vh();
  var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
  builder.ut(tmp$ret$0);
};
protoOf(UByteArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.rt(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UByteArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.rt(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UByteArraySerializer_0).vt = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.uj(this.on_1, i);
      // Inline function 'kotlin.UByte.toByte' call
      var this_0 = UByteArray__get_impl_t5f3hv(content, i);
      var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
      tmp.cj(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UByteArraySerializer_0).zn = function (encoder, content, size) {
  return this.vt(encoder, content instanceof UByteArray ? content.ee_1 : THROW_CCE(), size);
};
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance == null)
    new UByteArraySerializer_0();
  return UByteArraySerializer_instance;
}
function BooleanArraySerializer_0() {
  BooleanArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_12(BooleanCompanionObject_instance));
}
protoOf(BooleanArraySerializer_0).yt = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(BooleanArraySerializer_0).mm = function (_this__u8e3s4) {
  return this.yt((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(BooleanArraySerializer_0).zt = function (_this__u8e3s4) {
  return new BooleanArrayBuilder(_this__u8e3s4);
};
protoOf(BooleanArraySerializer_0).hl = function (_this__u8e3s4) {
  return this.zt((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(BooleanArraySerializer_0).xn = function () {
  return booleanArray(0);
};
protoOf(BooleanArraySerializer_0).au = function (decoder, index, builder, checkIndex) {
  builder.du(decoder.ii(this.on_1, index));
};
protoOf(BooleanArraySerializer_0).sl = function (decoder, index, builder, checkIndex) {
  return this.au(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(BooleanArraySerializer_0).yn = function (decoder, index, builder, checkIndex) {
  return this.au(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(BooleanArraySerializer_0).eu = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.lj(this.on_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(BooleanArraySerializer_0).zn = function (encoder, content, size) {
  return this.eu(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
};
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance == null)
    new BooleanArraySerializer_0();
  return BooleanArraySerializer_instance;
}
function CharArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.cq_1 = bufferWithData;
  this.dq_1 = bufferWithData.length;
  this.un(10);
}
protoOf(CharArrayBuilder).qn = function () {
  return this.dq_1;
};
protoOf(CharArrayBuilder).un = function (requiredCapacity) {
  if (this.cq_1.length < requiredCapacity)
    this.cq_1 = copyOf(this.cq_1, coerceAtLeast(requiredCapacity, imul(this.cq_1.length, 2)));
};
protoOf(CharArrayBuilder).eq = function (c) {
  this.bo();
  var tmp = this.cq_1;
  var _unary__edvuaz = this.dq_1;
  this.dq_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(CharArrayBuilder).sn = function () {
  return copyOf(this.cq_1, this.dq_1);
};
function DoubleArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.lq_1 = bufferWithData;
  this.mq_1 = bufferWithData.length;
  this.un(10);
}
protoOf(DoubleArrayBuilder).qn = function () {
  return this.mq_1;
};
protoOf(DoubleArrayBuilder).un = function (requiredCapacity) {
  if (this.lq_1.length < requiredCapacity)
    this.lq_1 = copyOf_0(this.lq_1, coerceAtLeast(requiredCapacity, imul(this.lq_1.length, 2)));
};
protoOf(DoubleArrayBuilder).nq = function (c) {
  this.bo();
  var tmp = this.lq_1;
  var _unary__edvuaz = this.mq_1;
  this.mq_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(DoubleArrayBuilder).sn = function () {
  return copyOf_0(this.lq_1, this.mq_1);
};
function FloatArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.uq_1 = bufferWithData;
  this.vq_1 = bufferWithData.length;
  this.un(10);
}
protoOf(FloatArrayBuilder).qn = function () {
  return this.vq_1;
};
protoOf(FloatArrayBuilder).un = function (requiredCapacity) {
  if (this.uq_1.length < requiredCapacity)
    this.uq_1 = copyOf_1(this.uq_1, coerceAtLeast(requiredCapacity, imul(this.uq_1.length, 2)));
};
protoOf(FloatArrayBuilder).wq = function (c) {
  this.bo();
  var tmp = this.uq_1;
  var _unary__edvuaz = this.vq_1;
  this.vq_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(FloatArrayBuilder).sn = function () {
  return copyOf_1(this.uq_1, this.vq_1);
};
function LongArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.dr_1 = bufferWithData;
  this.er_1 = bufferWithData.length;
  this.un(10);
}
protoOf(LongArrayBuilder).qn = function () {
  return this.er_1;
};
protoOf(LongArrayBuilder).un = function (requiredCapacity) {
  if (this.dr_1.length < requiredCapacity)
    this.dr_1 = copyOf_2(this.dr_1, coerceAtLeast(requiredCapacity, imul(this.dr_1.length, 2)));
};
protoOf(LongArrayBuilder).fr = function (c) {
  this.bo();
  var tmp = this.dr_1;
  var _unary__edvuaz = this.er_1;
  this.er_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(LongArrayBuilder).sn = function () {
  return copyOf_2(this.dr_1, this.er_1);
};
function ULongArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.nr_1 = bufferWithData;
  this.or_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
  this.un(10);
}
protoOf(ULongArrayBuilder).qn = function () {
  return this.or_1;
};
protoOf(ULongArrayBuilder).un = function (requiredCapacity) {
  if (_ULongArray___get_size__impl__ju6dtr(this.nr_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.nr_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.nr_1), 2));
    tmp.nr_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  }
};
protoOf(ULongArrayBuilder).pr = function (c) {
  this.bo();
  var tmp = this.nr_1;
  var _unary__edvuaz = this.or_1;
  this.or_1 = _unary__edvuaz + 1 | 0;
  ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
};
protoOf(ULongArrayBuilder).fu = function () {
  var tmp0 = this.nr_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.or_1;
  return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
};
protoOf(ULongArrayBuilder).sn = function () {
  return new ULongArray(this.fu());
};
function IntArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.wr_1 = bufferWithData;
  this.xr_1 = bufferWithData.length;
  this.un(10);
}
protoOf(IntArrayBuilder).qn = function () {
  return this.xr_1;
};
protoOf(IntArrayBuilder).un = function (requiredCapacity) {
  if (this.wr_1.length < requiredCapacity)
    this.wr_1 = copyOf_3(this.wr_1, coerceAtLeast(requiredCapacity, imul(this.wr_1.length, 2)));
};
protoOf(IntArrayBuilder).yr = function (c) {
  this.bo();
  var tmp = this.wr_1;
  var _unary__edvuaz = this.xr_1;
  this.xr_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(IntArrayBuilder).sn = function () {
  return copyOf_3(this.wr_1, this.xr_1);
};
function UIntArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.gs_1 = bufferWithData;
  this.hs_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
  this.un(10);
}
protoOf(UIntArrayBuilder).qn = function () {
  return this.hs_1;
};
protoOf(UIntArrayBuilder).un = function (requiredCapacity) {
  if (_UIntArray___get_size__impl__r6l8ci(this.gs_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.gs_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.gs_1), 2));
    tmp.gs_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  }
};
protoOf(UIntArrayBuilder).is = function (c) {
  this.bo();
  var tmp = this.gs_1;
  var _unary__edvuaz = this.hs_1;
  this.hs_1 = _unary__edvuaz + 1 | 0;
  UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
};
protoOf(UIntArrayBuilder).gu = function () {
  var tmp0 = this.gs_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.hs_1;
  return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
};
protoOf(UIntArrayBuilder).sn = function () {
  return new UIntArray(this.gu());
};
function ShortArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.ps_1 = bufferWithData;
  this.qs_1 = bufferWithData.length;
  this.un(10);
}
protoOf(ShortArrayBuilder).qn = function () {
  return this.qs_1;
};
protoOf(ShortArrayBuilder).un = function (requiredCapacity) {
  if (this.ps_1.length < requiredCapacity)
    this.ps_1 = copyOf_4(this.ps_1, coerceAtLeast(requiredCapacity, imul(this.ps_1.length, 2)));
};
protoOf(ShortArrayBuilder).rs = function (c) {
  this.bo();
  var tmp = this.ps_1;
  var _unary__edvuaz = this.qs_1;
  this.qs_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(ShortArrayBuilder).sn = function () {
  return copyOf_4(this.ps_1, this.qs_1);
};
function UShortArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.zs_1 = bufferWithData;
  this.at_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
  this.un(10);
}
protoOf(UShortArrayBuilder).qn = function () {
  return this.at_1;
};
protoOf(UShortArrayBuilder).un = function (requiredCapacity) {
  if (_UShortArray___get_size__impl__jqto1b(this.zs_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.zs_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.zs_1), 2));
    tmp.zs_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  }
};
protoOf(UShortArrayBuilder).bt = function (c) {
  this.bo();
  var tmp = this.zs_1;
  var _unary__edvuaz = this.at_1;
  this.at_1 = _unary__edvuaz + 1 | 0;
  UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
};
protoOf(UShortArrayBuilder).hu = function () {
  var tmp0 = this.zs_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.at_1;
  return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
};
protoOf(UShortArrayBuilder).sn = function () {
  return new UShortArray(this.hu());
};
function ByteArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.it_1 = bufferWithData;
  this.jt_1 = bufferWithData.length;
  this.un(10);
}
protoOf(ByteArrayBuilder).qn = function () {
  return this.jt_1;
};
protoOf(ByteArrayBuilder).un = function (requiredCapacity) {
  if (this.it_1.length < requiredCapacity)
    this.it_1 = copyOf_5(this.it_1, coerceAtLeast(requiredCapacity, imul(this.it_1.length, 2)));
};
protoOf(ByteArrayBuilder).kt = function (c) {
  this.bo();
  var tmp = this.it_1;
  var _unary__edvuaz = this.jt_1;
  this.jt_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(ByteArrayBuilder).sn = function () {
  return copyOf_5(this.it_1, this.jt_1);
};
function UByteArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.st_1 = bufferWithData;
  this.tt_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
  this.un(10);
}
protoOf(UByteArrayBuilder).qn = function () {
  return this.tt_1;
};
protoOf(UByteArrayBuilder).un = function (requiredCapacity) {
  if (_UByteArray___get_size__impl__h6pkdv(this.st_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.st_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.st_1), 2));
    tmp.st_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  }
};
protoOf(UByteArrayBuilder).ut = function (c) {
  this.bo();
  var tmp = this.st_1;
  var _unary__edvuaz = this.tt_1;
  this.tt_1 = _unary__edvuaz + 1 | 0;
  UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
};
protoOf(UByteArrayBuilder).iu = function () {
  var tmp0 = this.st_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.tt_1;
  return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
};
protoOf(UByteArrayBuilder).sn = function () {
  return new UByteArray(this.iu());
};
function BooleanArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.bu_1 = bufferWithData;
  this.cu_1 = bufferWithData.length;
  this.un(10);
}
protoOf(BooleanArrayBuilder).qn = function () {
  return this.cu_1;
};
protoOf(BooleanArrayBuilder).un = function (requiredCapacity) {
  if (this.bu_1.length < requiredCapacity)
    this.bu_1 = copyOf_6(this.bu_1, coerceAtLeast(requiredCapacity, imul(this.bu_1.length, 2)));
};
protoOf(BooleanArrayBuilder).du = function (c) {
  this.bo();
  var tmp = this.bu_1;
  var _unary__edvuaz = this.cu_1;
  this.cu_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(BooleanArrayBuilder).sn = function () {
  return copyOf_6(this.bu_1, this.cu_1);
};
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
function StringSerializer() {
  StringSerializer_instance = this;
  this.ju_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
}
protoOf(StringSerializer).jf = function () {
  return this.ju_1;
};
protoOf(StringSerializer).ku = function (encoder, value) {
  return encoder.jj(value);
};
protoOf(StringSerializer).kf = function (encoder, value) {
  return this.ku(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
};
protoOf(StringSerializer).lf = function (decoder) {
  return decoder.ci();
};
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance == null)
    new StringSerializer();
  return StringSerializer_instance;
}
function error_0($this) {
  throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
}
function PrimitiveSerialDescriptor_0(serialName, kind) {
  this.lu_1 = serialName;
  this.mu_1 = kind;
}
protoOf(PrimitiveSerialDescriptor_0).ng = function () {
  return this.lu_1;
};
protoOf(PrimitiveSerialDescriptor_0).og = function () {
  return this.mu_1;
};
protoOf(PrimitiveSerialDescriptor_0).qg = function () {
  return 0;
};
protoOf(PrimitiveSerialDescriptor_0).sg = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).tg = function (name) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).wg = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).vg = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).ug = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).toString = function () {
  return 'PrimitiveDescriptor(' + this.lu_1 + ')';
};
protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PrimitiveSerialDescriptor_0))
    return false;
  if (this.lu_1 === other.lu_1 && equals(this.mu_1, other.mu_1))
    return true;
  return false;
};
protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
  return getStringHashCode(this.lu_1) + imul(31, this.mu_1.hashCode()) | 0;
};
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().q1(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
}
function IntSerializer() {
  IntSerializer_instance = this;
  this.nu_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
}
protoOf(IntSerializer).jf = function () {
  return this.nu_1;
};
protoOf(IntSerializer).ou = function (encoder, value) {
  return encoder.ej(value);
};
protoOf(IntSerializer).kf = function (encoder, value) {
  return this.ou(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(IntSerializer).lf = function (decoder) {
  return decoder.xh();
};
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance == null)
    new IntSerializer();
  return IntSerializer_instance;
}
function LongSerializer() {
  LongSerializer_instance = this;
  this.pu_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
}
protoOf(LongSerializer).jf = function () {
  return this.pu_1;
};
protoOf(LongSerializer).qu = function (encoder, value) {
  return encoder.fj(value);
};
protoOf(LongSerializer).kf = function (encoder, value) {
  return this.qu(encoder, value instanceof Long ? value : THROW_CCE());
};
protoOf(LongSerializer).lf = function (decoder) {
  return decoder.yh();
};
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance == null)
    new LongSerializer();
  return LongSerializer_instance;
}
function ByteSerializer() {
  ByteSerializer_instance = this;
  this.ru_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
}
protoOf(ByteSerializer).jf = function () {
  return this.ru_1;
};
protoOf(ByteSerializer).su = function (encoder, value) {
  return encoder.cj(value);
};
protoOf(ByteSerializer).kf = function (encoder, value) {
  return this.su(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(ByteSerializer).lf = function (decoder) {
  return decoder.vh();
};
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance == null)
    new ByteSerializer();
  return ByteSerializer_instance;
}
function ShortSerializer() {
  ShortSerializer_instance = this;
  this.tu_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
}
protoOf(ShortSerializer).jf = function () {
  return this.tu_1;
};
protoOf(ShortSerializer).uu = function (encoder, value) {
  return encoder.dj(value);
};
protoOf(ShortSerializer).kf = function (encoder, value) {
  return this.uu(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(ShortSerializer).lf = function (decoder) {
  return decoder.wh();
};
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance == null)
    new ShortSerializer();
  return ShortSerializer_instance;
}
function CharSerializer() {
  CharSerializer_instance = this;
  this.vu_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
}
protoOf(CharSerializer).jf = function () {
  return this.vu_1;
};
protoOf(CharSerializer).wu = function (encoder, value) {
  return encoder.ij(value);
};
protoOf(CharSerializer).kf = function (encoder, value) {
  return this.wu(encoder, value instanceof Char ? value.x_1 : THROW_CCE());
};
protoOf(CharSerializer).xu = function (decoder) {
  return decoder.bi();
};
protoOf(CharSerializer).lf = function (decoder) {
  return new Char(this.xu(decoder));
};
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance == null)
    new CharSerializer();
  return CharSerializer_instance;
}
function DoubleSerializer() {
  DoubleSerializer_instance = this;
  this.yu_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
}
protoOf(DoubleSerializer).jf = function () {
  return this.yu_1;
};
protoOf(DoubleSerializer).zu = function (encoder, value) {
  return encoder.hj(value);
};
protoOf(DoubleSerializer).kf = function (encoder, value) {
  return this.zu(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(DoubleSerializer).lf = function (decoder) {
  return decoder.ai();
};
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance == null)
    new DoubleSerializer();
  return DoubleSerializer_instance;
}
function FloatSerializer() {
  FloatSerializer_instance = this;
  this.av_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
}
protoOf(FloatSerializer).jf = function () {
  return this.av_1;
};
protoOf(FloatSerializer).bv = function (encoder, value) {
  return encoder.gj(value);
};
protoOf(FloatSerializer).kf = function (encoder, value) {
  return this.bv(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(FloatSerializer).lf = function (decoder) {
  return decoder.zh();
};
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance == null)
    new FloatSerializer();
  return FloatSerializer_instance;
}
function BooleanSerializer() {
  BooleanSerializer_instance = this;
  this.cv_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
}
protoOf(BooleanSerializer).jf = function () {
  return this.cv_1;
};
protoOf(BooleanSerializer).dv = function (encoder, value) {
  return encoder.bj(value);
};
protoOf(BooleanSerializer).kf = function (encoder, value) {
  return this.dv(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
};
protoOf(BooleanSerializer).lf = function (decoder) {
  return decoder.uh();
};
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance == null)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
function UnitSerializer() {
  UnitSerializer_instance = this;
  this.ev_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
}
protoOf(UnitSerializer).jf = function () {
  return this.ev_1.jf();
};
protoOf(UnitSerializer).fv = function (encoder, value) {
  this.ev_1.zf(encoder, Unit_instance);
};
protoOf(UnitSerializer).kf = function (encoder, value) {
  return this.fv(encoder, value instanceof Unit ? value : THROW_CCE());
};
protoOf(UnitSerializer).gv = function (decoder) {
  this.ev_1.lf(decoder);
};
protoOf(UnitSerializer).lf = function (decoder) {
  this.gv(decoder);
  return Unit_instance;
};
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance == null)
    new UnitSerializer();
  return UnitSerializer_instance;
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkName(serialName);
  return new PrimitiveSerialDescriptor_0(serialName, kind);
}
function checkName(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().s1();
  var _iterator__ex2g4s = values.h();
  while (_iterator__ex2g4s.i()) {
    var primitive = _iterator__ex2g4s.j();
    var primitiveName = primitive.jf().ng();
    if (serialName === primitiveName) {
      throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).v7() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
function NamedValueDecoder() {
  TaggedDecoder.call(this);
}
protoOf(NamedValueDecoder).jv = function (_this__u8e3s4, index) {
  return this.lv(this.kv(_this__u8e3s4, index));
};
protoOf(NamedValueDecoder).lv = function (nestedName) {
  var tmp0_elvis_lhs = this.ov();
  return this.pv(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
};
protoOf(NamedValueDecoder).kv = function (descriptor, index) {
  return descriptor.sg(index);
};
protoOf(NamedValueDecoder).pv = function (parentName, childName) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(parentName) === 0) {
    tmp = childName;
  } else {
    tmp = parentName + '.' + childName;
  }
  return tmp;
};
protoOf(NamedValueDecoder).qv = function () {
  return this.mv_1.l() ? '$' : joinToString(this.mv_1, '.', '$.');
};
function tagBlock($this, tag, block) {
  $this.dw(tag);
  var r = block();
  if (!$this.nv_1) {
    $this.ew();
  }
  $this.nv_1 = false;
  return r;
}
function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    return this$0.ei($deserializer, $previousValue);
  };
}
function TaggedDecoder() {
  var tmp = this;
  // Inline function 'kotlin.collections.arrayListOf' call
  tmp.mv_1 = ArrayList_init_$Create$_0();
  this.nv_1 = false;
}
protoOf(TaggedDecoder).ui = function () {
  return EmptySerializersModule_0();
};
protoOf(TaggedDecoder).rv = function (tag) {
  throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
};
protoOf(TaggedDecoder).sv = function (tag) {
  return true;
};
protoOf(TaggedDecoder).tv = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'boolean' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).uv = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).vv = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).wv = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).xv = function (tag) {
  var tmp = this.rv(tag);
  return tmp instanceof Long ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).yv = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).zv = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).aw = function (tag) {
  var tmp = this.rv(tag);
  return tmp instanceof Char ? tmp.x_1 : THROW_CCE();
};
protoOf(TaggedDecoder).bw = function (tag) {
  var tmp = this.rv(tag);
  return typeof tmp === 'string' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).cw = function (tag, inlineDescriptor) {
  // Inline function 'kotlin.apply' call
  this.dw(tag);
  return this;
};
protoOf(TaggedDecoder).ei = function (deserializer, previousValue) {
  return this.fi(deserializer);
};
protoOf(TaggedDecoder).di = function (descriptor) {
  return this.cw(this.ew(), descriptor);
};
protoOf(TaggedDecoder).sh = function () {
  var tmp0_elvis_lhs = this.ov();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var currentTag = tmp;
  return this.sv(currentTag);
};
protoOf(TaggedDecoder).th = function () {
  return null;
};
protoOf(TaggedDecoder).uh = function () {
  return this.tv(this.ew());
};
protoOf(TaggedDecoder).vh = function () {
  return this.uv(this.ew());
};
protoOf(TaggedDecoder).wh = function () {
  return this.vv(this.ew());
};
protoOf(TaggedDecoder).xh = function () {
  return this.wv(this.ew());
};
protoOf(TaggedDecoder).yh = function () {
  return this.xv(this.ew());
};
protoOf(TaggedDecoder).zh = function () {
  return this.yv(this.ew());
};
protoOf(TaggedDecoder).ai = function () {
  return this.zv(this.ew());
};
protoOf(TaggedDecoder).bi = function () {
  return this.aw(this.ew());
};
protoOf(TaggedDecoder).ci = function () {
  return this.bw(this.ew());
};
protoOf(TaggedDecoder).gi = function (descriptor) {
  return this;
};
protoOf(TaggedDecoder).hi = function (descriptor) {
};
protoOf(TaggedDecoder).ii = function (descriptor, index) {
  return this.tv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).ji = function (descriptor, index) {
  return this.uv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).ki = function (descriptor, index) {
  return this.vv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).li = function (descriptor, index) {
  return this.wv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).mi = function (descriptor, index) {
  return this.xv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).ni = function (descriptor, index) {
  return this.yv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).oi = function (descriptor, index) {
  return this.zv(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).pi = function (descriptor, index) {
  return this.aw(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).qi = function (descriptor, index) {
  return this.bw(this.jv(descriptor, index));
};
protoOf(TaggedDecoder).ri = function (descriptor, index) {
  return this.cw(this.jv(descriptor, index), descriptor.vg(index));
};
protoOf(TaggedDecoder).si = function (descriptor, index, deserializer, previousValue) {
  var tmp = this.jv(descriptor, index);
  return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
};
protoOf(TaggedDecoder).ov = function () {
  return lastOrNull(this.mv_1);
};
protoOf(TaggedDecoder).dw = function (name) {
  this.mv_1.f(name);
};
protoOf(TaggedDecoder).ew = function () {
  var r = this.mv_1.v1(get_lastIndex_0(this.mv_1));
  this.nv_1 = true;
  return r;
};
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntry(key, value) {
  this.fw_1 = key;
  this.gw_1 = value;
}
protoOf(MapEntry).m1 = function () {
  return this.fw_1;
};
protoOf(MapEntry).n1 = function () {
  return this.gw_1;
};
protoOf(MapEntry).toString = function () {
  return 'MapEntry(key=' + toString_0(this.fw_1) + ', value=' + toString_0(this.gw_1) + ')';
};
protoOf(MapEntry).hashCode = function () {
  var result = this.fw_1 == null ? 0 : hashCode(this.fw_1);
  result = imul(result, 31) + (this.gw_1 == null ? 0 : hashCode(this.gw_1)) | 0;
  return result;
};
protoOf(MapEntry).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MapEntry))
    return false;
  var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
  if (!equals(this.fw_1, tmp0_other_with_cast.fw_1))
    return false;
  if (!equals(this.gw_1, tmp0_other_with_cast.gw_1))
    return false;
  return true;
};
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.uf('key', $keySerializer.jf());
    $this$buildSerialDescriptor.uf('value', $valueSerializer.jf());
    return Unit_instance;
  };
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  KeyValueSerializer.call(this, keySerializer, valueSerializer);
  var tmp = this;
  var tmp_0 = MAP_getInstance();
  tmp.jw_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
}
protoOf(MapEntrySerializer_0).jf = function () {
  return this.jw_1;
};
protoOf(MapEntrySerializer_0).kw = function (_this__u8e3s4) {
  return _this__u8e3s4.m1();
};
protoOf(MapEntrySerializer_0).lw = function (_this__u8e3s4) {
  return this.kw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(MapEntrySerializer_0).mw = function (_this__u8e3s4) {
  return _this__u8e3s4.n1();
};
protoOf(MapEntrySerializer_0).nw = function (_this__u8e3s4) {
  return this.mw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(MapEntrySerializer_0).ow = function (key, value) {
  return new MapEntry(key, value);
};
function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.uf('first', $keySerializer.jf());
    $this$buildClassSerialDescriptor.uf('second', $valueSerializer.jf());
    return Unit_instance;
  };
}
function PairSerializer_0(keySerializer, valueSerializer) {
  KeyValueSerializer.call(this, keySerializer, valueSerializer);
  var tmp = this;
  tmp.uw_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
}
protoOf(PairSerializer_0).jf = function () {
  return this.uw_1;
};
protoOf(PairSerializer_0).vw = function (_this__u8e3s4) {
  return _this__u8e3s4.qa_1;
};
protoOf(PairSerializer_0).lw = function (_this__u8e3s4) {
  return this.vw(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PairSerializer_0).ww = function (_this__u8e3s4) {
  return _this__u8e3s4.ra_1;
};
protoOf(PairSerializer_0).nw = function (_this__u8e3s4) {
  return this.ww(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PairSerializer_0).ow = function (key, value) {
  return to(key, value);
};
function decodeSequentially_1($this, composite) {
  var a = composite.ti($this.ax_1, 0, $this.xw_1);
  var b = composite.ti($this.ax_1, 1, $this.yw_1);
  var c = composite.ti($this.ax_1, 2, $this.zw_1);
  composite.hi($this.ax_1);
  return new Triple(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.wi($this.ax_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.ti($this.ax_1, 0, $this.xw_1);
        break;
      case 1:
        b = composite.ti($this.ax_1, 1, $this.yw_1);
        break;
      case 2:
        c = composite.ti($this.ax_1, 2, $this.zw_1);
        break;
      default:
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
  }
  composite.hi($this.ax_1);
  if (a === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
function TripleSerializer$descriptor$lambda(this$0) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.uf('first', this$0.xw_1.jf());
    $this$buildClassSerialDescriptor.uf('second', this$0.yw_1.jf());
    $this$buildClassSerialDescriptor.uf('third', this$0.zw_1.jf());
    return Unit_instance;
  };
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  this.xw_1 = aSerializer;
  this.yw_1 = bSerializer;
  this.zw_1 = cSerializer;
  var tmp = this;
  tmp.ax_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
}
protoOf(TripleSerializer_0).jf = function () {
  return this.ax_1;
};
protoOf(TripleSerializer_0).bx = function (encoder, value) {
  var structuredEncoder = encoder.gi(this.ax_1);
  structuredEncoder.vj(this.ax_1, 0, this.xw_1, value.nd_1);
  structuredEncoder.vj(this.ax_1, 1, this.yw_1, value.od_1);
  structuredEncoder.vj(this.ax_1, 2, this.zw_1, value.pd_1);
  structuredEncoder.hi(this.ax_1);
};
protoOf(TripleSerializer_0).kf = function (encoder, value) {
  return this.bx(encoder, value instanceof Triple ? value : THROW_CCE());
};
protoOf(TripleSerializer_0).lf = function (decoder) {
  var composite = decoder.gi(this.ax_1);
  if (composite.vi()) {
    return decodeSequentially_1(this, composite);
  }
  return decodeStructure(this, composite);
};
function KeyValueSerializer(keySerializer, valueSerializer) {
  this.pw_1 = keySerializer;
  this.qw_1 = valueSerializer;
}
protoOf(KeyValueSerializer).rw = function (encoder, value) {
  var structuredEncoder = encoder.gi(this.jf());
  structuredEncoder.vj(this.jf(), 0, this.pw_1, this.lw(value));
  structuredEncoder.vj(this.jf(), 1, this.qw_1, this.nw(value));
  structuredEncoder.hi(this.jf());
};
protoOf(KeyValueSerializer).kf = function (encoder, value) {
  return this.rw(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(KeyValueSerializer).lf = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.jf();
  var composite = decoder.gi(descriptor);
  var tmp$ret$0;
  $l$block: {
    if (composite.vi()) {
      var key = composite.ti(this.jf(), 0, this.pw_1);
      var value = composite.ti(this.jf(), 1, this.qw_1);
      tmp$ret$0 = this.ow(key, value);
      break $l$block;
    }
    var key_0 = get_NULL();
    var value_0 = get_NULL();
    mainLoop: while (true) {
      var idx = composite.wi(this.jf());
      switch (idx) {
        case -1:
          break mainLoop;
        case 0:
          key_0 = composite.ti(this.jf(), 0, this.pw_1);
          break;
        case 1:
          value_0 = composite.ti(this.jf(), 1, this.qw_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
      }
    }
    if (key_0 === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'key' is missing");
    if (value_0 === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'value' is missing");
    var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
    tmp$ret$0 = this.ow(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
  }
  var result = tmp$ret$0;
  composite.hi(descriptor);
  return result;
};
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
function UIntSerializer() {
  UIntSerializer_instance = this;
  this.cx_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_5(IntCompanionObject_instance));
}
protoOf(UIntSerializer).jf = function () {
  return this.cx_1;
};
protoOf(UIntSerializer).dx = function (encoder, value) {
  var tmp = encoder.kj(this.cx_1);
  // Inline function 'kotlin.UInt.toInt' call
  var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
  tmp.ej(tmp$ret$0);
};
protoOf(UIntSerializer).kf = function (encoder, value) {
  return this.dx(encoder, value instanceof UInt ? value.je_1 : THROW_CCE());
};
protoOf(UIntSerializer).ex = function (decoder) {
  // Inline function 'kotlin.toUInt' call
  var this_0 = decoder.di(this.cx_1).xh();
  return _UInt___init__impl__l7qpdl(this_0);
};
protoOf(UIntSerializer).lf = function (decoder) {
  return new UInt(this.ex(decoder));
};
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance == null)
    new UIntSerializer();
  return UIntSerializer_instance;
}
function ULongSerializer() {
  ULongSerializer_instance = this;
  this.fx_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_6(Companion_getInstance_2()));
}
protoOf(ULongSerializer).jf = function () {
  return this.fx_1;
};
protoOf(ULongSerializer).gx = function (encoder, value) {
  var tmp = encoder.kj(this.fx_1);
  // Inline function 'kotlin.ULong.toLong' call
  var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
  tmp.fj(tmp$ret$0);
};
protoOf(ULongSerializer).kf = function (encoder, value) {
  return this.gx(encoder, value instanceof ULong ? value.te_1 : THROW_CCE());
};
protoOf(ULongSerializer).hx = function (decoder) {
  // Inline function 'kotlin.toULong' call
  var this_0 = decoder.di(this.fx_1).yh();
  return _ULong___init__impl__c78o9k(this_0);
};
protoOf(ULongSerializer).lf = function (decoder) {
  return new ULong(this.hx(decoder));
};
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance == null)
    new ULongSerializer();
  return ULongSerializer_instance;
}
function UByteSerializer() {
  UByteSerializer_instance = this;
  this.ix_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_7(ByteCompanionObject_instance));
}
protoOf(UByteSerializer).jf = function () {
  return this.ix_1;
};
protoOf(UByteSerializer).jx = function (encoder, value) {
  var tmp = encoder.kj(this.ix_1);
  // Inline function 'kotlin.UByte.toByte' call
  var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
  tmp.cj(tmp$ret$0);
};
protoOf(UByteSerializer).kf = function (encoder, value) {
  return this.jx(encoder, value instanceof UByte ? value.zd_1 : THROW_CCE());
};
protoOf(UByteSerializer).kx = function (decoder) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = decoder.di(this.ix_1).vh();
  return _UByte___init__impl__g9hnc4(this_0);
};
protoOf(UByteSerializer).lf = function (decoder) {
  return new UByte(this.kx(decoder));
};
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance == null)
    new UByteSerializer();
  return UByteSerializer_instance;
}
function UShortSerializer() {
  UShortSerializer_instance = this;
  this.lx_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_instance));
}
protoOf(UShortSerializer).jf = function () {
  return this.lx_1;
};
protoOf(UShortSerializer).mx = function (encoder, value) {
  var tmp = encoder.kj(this.lx_1);
  // Inline function 'kotlin.UShort.toShort' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
  tmp.dj(tmp$ret$0);
};
protoOf(UShortSerializer).kf = function (encoder, value) {
  return this.mx(encoder, value instanceof UShort ? value.df_1 : THROW_CCE());
};
protoOf(UShortSerializer).nx = function (decoder) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = decoder.di(this.lx_1).wh();
  return _UShort___init__impl__jigrne(this_0);
};
protoOf(UShortSerializer).lf = function (decoder) {
  return new UShort(this.nx(decoder));
};
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance == null)
    new UShortSerializer();
  return UShortSerializer_instance;
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
function SerializersModule() {
}
protoOf(SerializersModule).fg = function (kClass, typeArgumentsSerializers, $super) {
  typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
  return $super === VOID ? this.gg(kClass, typeArgumentsSerializers) : $super.gg.call(this, kClass, typeArgumentsSerializers);
};
function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
  SerializersModule.call(this);
  this.ox_1 = class2ContextualFactory;
  this.px_1 = polyBase2Serializers;
  this.qx_1 = polyBase2DefaultSerializerProvider;
  this.rx_1 = polyBase2NamedSerializers;
  this.sx_1 = polyBase2DefaultDeserializerProvider;
  this.tx_1 = hasInterfaceContextualSerializers;
}
protoOf(SerialModuleImpl).eg = function () {
  return this.tx_1;
};
protoOf(SerialModuleImpl).ak = function (baseClass, value) {
  if (!baseClass.w7(value))
    return null;
  var tmp0_safe_receiver = this.px_1.q1(baseClass);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q1(getKClassFromExpression(value));
  var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
  if (!(registered == null))
    return registered;
  var tmp_0 = this.qx_1.q1(baseClass);
  var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
};
protoOf(SerialModuleImpl).zj = function (baseClass, serializedClassName) {
  var tmp0_safe_receiver = this.rx_1.q1(baseClass);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.get' call
    tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).q1(serializedClassName);
  }
  var tmp_0 = tmp;
  var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
  if (!(registered == null))
    return registered;
  var tmp_1 = this.sx_1.q1(baseClass);
  var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
};
protoOf(SerialModuleImpl).gg = function (kClass, typeArgumentsSerializers) {
  var tmp0_safe_receiver = this.ox_1.q1(kClass);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ux(typeArgumentsSerializers);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
};
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function SerializableWith(serializer) {
  this.vx_1 = serializer;
}
protoOf(SerializableWith).equals = function (other) {
  if (!(other instanceof SerializableWith))
    return false;
  var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
  if (!this.vx_1.equals(tmp0_other_with_cast.vx_1))
    return false;
  return true;
};
protoOf(SerializableWith).hashCode = function () {
  return imul(getStringHashCode('serializer'), 127) ^ this.vx_1.hashCode();
};
protoOf(SerializableWith).toString = function () {
  return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.vx_1) + ')';
};
function createCache(factory) {
  return new createCache$1(factory);
}
function createParametrizedCache(factory) {
  return new createParametrizedCache$1(factory);
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterface(_this__u8e3s4);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function initBuiltins() {
  return mapOf([to(PrimitiveClasses_getInstance().w8(), serializer_0(StringCompanionObject_instance)), to(getKClass(Char), serializer_9(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().z8(), CharArraySerializer()), to(PrimitiveClasses_getInstance().u8(), serializer_10(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().f9(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().t8(), serializer_11(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().e9(), FloatArraySerializer()), to(getKClass(Long), serializer_6(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().d9(), LongArraySerializer()), to(getKClass(ULong), serializer_2(Companion_getInstance_3())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().r8(), serializer_5(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().c9(), IntArraySerializer()), to(getKClass(UInt), serializer_1(Companion_getInstance_4())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().q8(), serializer_8(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().b9(), ShortArraySerializer()), to(getKClass(UShort), serializer_4(Companion_getInstance_5())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().p8(), serializer_7(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().a9(), ByteArraySerializer()), to(getKClass(UByte), serializer_3(Companion_getInstance_6())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().o8(), serializer_12(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().y8(), BooleanArraySerializer()), to(getKClass(Unit), serializer_13(Unit_instance)), to(PrimitiveClasses_getInstance().n8(), NothingSerializer()), to(getKClass(Duration), serializer_14(Companion_getInstance())), to(getKClass(Uuid), serializer_15(Companion_getInstance_0()))]);
}
function get_isInterface(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().n8())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
}
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().n8()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().v8());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
      tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
        var tmp_1 = assocObject.wp(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function createCache$1($factory) {
  this.wx_1 = $factory;
}
protoOf(createCache$1).hg = function (key) {
  return this.wx_1(key);
};
function createParametrizedCache$1($factory) {
  this.xx_1 = $factory;
}
protoOf(createParametrizedCache$1).ig = function (key, types) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = this.xx_1(key, types);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
//region block: post-declaration
protoOf(SerialDescriptorImpl).jg = get_isNullable;
protoOf(SerialDescriptorImpl).pg = get_isInline;
protoOf(AbstractDecoder).ti = decodeSerializableElement$default;
protoOf(AbstractDecoder).fi = decodeSerializableValue;
protoOf(AbstractDecoder).vi = decodeSequentially;
protoOf(AbstractDecoder).xi = decodeCollectionSize;
protoOf(AbstractEncoder).xj = encodeNotNullMark;
protoOf(AbstractEncoder).yj = beginCollection;
protoOf(AbstractEncoder).wj = encodeSerializableValue;
protoOf(ListLikeDescriptor).jg = get_isNullable;
protoOf(ListLikeDescriptor).pg = get_isInline;
protoOf(ListLikeDescriptor).rg = get_annotations;
protoOf(MapLikeDescriptor).jg = get_isNullable;
protoOf(MapLikeDescriptor).pg = get_isInline;
protoOf(MapLikeDescriptor).rg = get_annotations;
protoOf(PluginGeneratedSerialDescriptor).jg = get_isNullable;
protoOf(PluginGeneratedSerialDescriptor).pg = get_isInline;
protoOf(InlinePrimitiveDescriptor$1).mp = typeParametersSerializers;
protoOf(NothingSerialDescriptor).jg = get_isNullable;
protoOf(NothingSerialDescriptor).pg = get_isInline;
protoOf(NothingSerialDescriptor).rg = get_annotations;
protoOf(PrimitiveSerialDescriptor_0).jg = get_isNullable;
protoOf(PrimitiveSerialDescriptor_0).pg = get_isInline;
protoOf(PrimitiveSerialDescriptor_0).rg = get_annotations;
protoOf(TaggedDecoder).ti = decodeSerializableElement$default;
protoOf(TaggedDecoder).fi = decodeSerializableValue;
protoOf(TaggedDecoder).vi = decodeSequentially;
protoOf(TaggedDecoder).xi = decodeCollectionSize;
//endregion
//region block: exports
export {
  SerializationException_init_$Init$_0 as SerializationException_init_$Init$nhp5tm45z5re,
  UnknownFieldException_init_$Create$ as UnknownFieldException_init_$Create$hprktcyan42n,
  SEALED_getInstance as SEALED_getInstance3nsev85ow9059,
  STRING_getInstance as STRING_getInstance2ou4lro9xn2qn,
  CONTEXTUAL_getInstance as CONTEXTUAL_getInstance1845118lbzky0,
  ENUM_getInstance as ENUM_getInstance22lfbrqor0c0a,
  CLASS_getInstance as CLASS_getInstance14ex35co4jkrb,
  LIST_getInstance as LIST_getInstancey7k5h8d5cvxt,
  MAP_getInstance as MAP_getInstance3s1t6byguxmp9,
  OBJECT_getInstance as OBJECT_getInstance26229tfe4t547,
  BooleanSerializer_getInstance as BooleanSerializer_getInstance1t8habeqgiyq1,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance3da4hv5ndgjlx,
  IntSerializer_getInstance as IntSerializer_getInstance2q7s8kvk1il5u,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  serializer_0 as serializer1x79l67jvwntn,
  serializer_4 as serializer1q7c5q67ysppr,
  serializer_1 as serializer3ikrxnm8b29d6,
  serializer_3 as serializer36584sjyg5661,
  serializer_2 as serializer2lw83vwvpnyms,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  get_annotations as get_annotationshjxdbdcl8kmv,
  get_isInline as get_isInline5x26qrhi9qs6,
  get_isNullable as get_isNullable36pbikm8xb7bz,
  SerialDescriptor as SerialDescriptor2pelqekb5ic3a,
  ENUM as ENUMlmq49cvwy4ow,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  Decoder as Decoder23nde051s631g,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  findPolymorphicSerializer_0 as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer as findPolymorphicSerializerk638ixyjovk5,
  serializer as serializer1i4e9ym37oxmo,
};
//endregion

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-core.mjs.map
